webpackJsonp([3],{

/***/ 129:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WidgetV2_vue__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ad4bb290_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WidgetV2_vue__ = __webpack_require__(137);
function injectStyle (ssrContext) {
  __webpack_require__(130)
}
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ad4bb290"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WidgetV2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ad4bb290_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WidgetV2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 13:
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),

/***/ 130:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 131:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SignaturePad_vue__ = __webpack_require__(88);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'widget',
  components: {
    SignaturePad: __WEBPACK_IMPORTED_MODULE_0__SignaturePad_vue__["a" /* default */]
  },
  data: function data() {
    return {
      input: {
        name: '',
        address: '',
        postalCode: '',
        city: '',
        taxArray: [],
        email: '',
        phone: ''
      },
      signaturePadKey: 1,
      shouldShowSignatureForm: false,
      signatureFormHasErrors: true,
      signatureDataUrl: null,
      signedPdfSubmitted: false,
      pdfSubmitting: false
    };
  },
  mounted: function mounted() {
    var s = document.createElement('script');
    s.src = 'https://cdnjs.cloudflare.com/ajax/libs/iframe-resizer/4.3.2/iframeResizer.contentWindow.min.js';
    document.body.appendChild(s);
  },

  watch: {
    'input.postalCode': function handler(newVal) {
      var _this = this;

      if (newVal && newVal.length === 4) {
        $.getJSON('/enprocent/getFURS/' + newVal + '/').done(function (data) {
          _this.input.city = data.city;
        });
      }
    }
  },
  computed: {
    taxNumberArray: function taxNumberArray() {
      if (this.taxNumber && this.taxNumber.length === 8) {
        return this.taxNumber.split('');
      }
      return [0, 0, 0, 0, 0, 0, 0, 0];
    },
    inputTaxNumber: function inputTaxNumber() {
      return this.input.taxArray.join('');
    },
    linkToPDF: function linkToPDF() {
      var selected = this.name + '|=|' + this.taxNumber + '|=|' + this.percent;

      var url = '/pdf/genPDFfromPOST/?template=dobrodelen_pdf&filename=obrazec_enprocent';
      url += '&source_domain=' + encodeURIComponent(this.sourceDomain);
      if (this.signedPdfSubmitted) {
        url += '&skip_save=true';
      }
      url += '&selected_orgs=' + encodeURIComponent(selected);
      url += '&name=' + encodeURIComponent(this.input.name);
      url += '&address=' + encodeURIComponent(this.input.address);
      url += '&postalCode=' + encodeURIComponent(this.input.postalCode);
      url += '&city=' + encodeURIComponent(this.input.city);
      url += '&taxNumber=' + encodeURIComponent(this.inputTaxNumber);
      url += '&email=' + encodeURIComponent(this.input.email);
      url += '&phone=' + encodeURIComponent(this.input.phone);
      if (this.signatureDataUrl) {
        url += '&signature=' + encodeURIComponent(this.signatureDataUrl);
      }

      return url;
    },
    inputHasErrors: function inputHasErrors() {
      var _this2 = this;

      if (Object.keys(this.input).some(function (e) {
        return !_this2.input[e];
      })) {
        return true;
      }
      if (this.input.name.trim().length < 3 || this.input.name.trim().indexOf(' ') === -1) {
        return true;
      }
      if (this.input.address.trim().length < 3) {
        return true;
      }
      if (!/^\d{4}$/.test(this.input.postalCode)) {
        return true;
      }
      if (this.input.city.trim().length < 2) {
        return true;
      }
      if (!/^\d{8}$/.test(this.inputTaxNumber)) {
        return true;
      }
      var phone = this.input.phone.replace(/\D/g, '');
      if (phone.length < 7) {
        return true;
      }
      if (!this.input.email.includes('@') || !this.input.email.includes('.')) {
        return true;
      }
      return false;
    },
    showSendToCnvosButton: function showSendToCnvosButton() {
      var now = new Date();
      var month = now.getMonth() + 1;
      if (month === 12) {
        return now.getDate() < 21;
      }
      return true;
    }
  },
  props: {
    name: { type: String, required: true },
    address: { type: String, required: true },
    postalCode: { type: String, required: true },
    city: { type: String, required: true },
    taxNumber: { type: String, required: true },
    percent: { type: String, required: true },
    sourceDomain: { type: String, required: true }
  },
  methods: {
    focusNext: function focusNext(event) {
      if (event.target && event.target.nextElementSibling && event.target.nextElementSibling.tagName === 'INPUT') {
        event.target.nextElementSibling.select();
      }
    },
    onLinkToPDFClick: function onLinkToPDFClick(event) {
      if (this.inputHasErrors) {
        event.preventDefault();
        return;
      }
    },
    showSignatureForm: function showSignatureForm() {
      this.shouldShowSignatureForm = true;
    },
    onSignatureChange: function onSignatureChange(pad) {
      this.signatureFormHasErrors = pad.isEmpty();
      this.signatureDataUrl = pad.toDataURL();
    },
    onSignatureReady: function onSignatureReady(pad) {
      this.signatureFormHasErrors = true;
      this.signatureDataUrl = null;
      this.signedPdfSubmitted = false;
    },
    resetSignature: function resetSignature() {
      this.signaturePadKey++;
    },
    onSubmitPDF: function onSubmitPDF(event) {
      var _this3 = this;

      this.pdfSubmitting = true;

      var selected = this.name + '|=|' + this.taxNumber + '|=|' + this.percent;

      var formData = new FormData();
      formData.append("template", "dobrodelen_pdf");
      formData.append("filename", "obrazec_enprocent");
      formData.append("source_domain", this.sourceDomain);
      if (this.signedPdfSubmitted) {
        formData.append("skip_save", "true");
      }
      formData.append("selected_orgs", selected);
      formData.append("name", this.input.name);
      formData.append("address", this.input.address);
      formData.append("postalCode", this.input.postalCode);
      formData.append("city", this.input.city);
      formData.append("taxNumber", this.inputTaxNumber);
      formData.append("email", this.input.email);
      formData.append("phone", this.input.phone);
      formData.append("signature", this.signatureDataUrl);

      $.ajax({
        url: '/pdf/genPDFfromPOST/',
        data: formData,
        processData: false,
        contentType: false,
        type: 'POST',
        success: function success() {
          _this3.signedPdfSubmitted = true;
          _this3.pdfSubmitting = false;
        }
      });
    }
  }
});

/***/ }),

/***/ 132:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(133);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(14)("30787eaf", content, true, {});

/***/ }),

/***/ 133:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(13)(undefined);
// imports


// module
exports.push([module.i, ".signature-container[data-v-0f348213]{background:#e0e0e0;position:relative}.signature-container .safe-area[data-v-0f348213],.signature-container canvas[data-v-0f348213]{position:absolute;top:0;left:0;bottom:0;right:0;background:transparent}.signature-container .safe-area[data-v-0f348213]{border-bottom:1px solid #000;margin:0 30px 40px}", ""]);

// exports


/***/ }),

/***/ 134:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_signature_pad__ = __webpack_require__(135);
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      pad: null,
      width: 500,
      height: 150,
      safeArea: [30, 40]
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.width = Math.min(500, window.innerWidth);
    this.height = this.width * 0.3;
    this.safeArea = [this.width * 0.06, this.width * 0.08];

    var canvas = this.$refs.signature;
    canvas.width = this.width;
    canvas.height = this.height;

    this.pad = new __WEBPACK_IMPORTED_MODULE_0_signature_pad__["a" /* default */](canvas, {
      onEnd: function onEnd() {
        _this.$emit("change", _this.pad);
      }
    });
    this.$emit("ready", this.pad);
  },
  beforeDestroy: function beforeDestroy() {
    this.pad.off();
    this.pad = null;
  }
});

/***/ }),

/***/ 135:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*!
 * Signature Pad v3.0.0-beta.4 | https://github.com/szimek/signature_pad
 * (c) 2020 Szymon Nowak | Released under the MIT license
 */

var Point = function () {
    function Point(x, y, time) {
        _classCallCheck(this, Point);

        this.x = x;
        this.y = y;
        this.time = time || Date.now();
    }

    _createClass(Point, [{
        key: 'distanceTo',
        value: function distanceTo(start) {
            return Math.sqrt(Math.pow(this.x - start.x, 2) + Math.pow(this.y - start.y, 2));
        }
    }, {
        key: 'equals',
        value: function equals(other) {
            return this.x === other.x && this.y === other.y && this.time === other.time;
        }
    }, {
        key: 'velocityFrom',
        value: function velocityFrom(start) {
            return this.time !== start.time ? this.distanceTo(start) / (this.time - start.time) : 0;
        }
    }]);

    return Point;
}();

var Bezier = function () {
    function Bezier(startPoint, control2, control1, endPoint, startWidth, endWidth) {
        _classCallCheck(this, Bezier);

        this.startPoint = startPoint;
        this.control2 = control2;
        this.control1 = control1;
        this.endPoint = endPoint;
        this.startWidth = startWidth;
        this.endWidth = endWidth;
    }

    _createClass(Bezier, [{
        key: 'length',
        value: function length() {
            var steps = 10;
            var length = 0;
            var px = void 0;
            var py = void 0;
            for (var i = 0; i <= steps; i += 1) {
                var t = i / steps;
                var cx = this.point(t, this.startPoint.x, this.control1.x, this.control2.x, this.endPoint.x);
                var cy = this.point(t, this.startPoint.y, this.control1.y, this.control2.y, this.endPoint.y);
                if (i > 0) {
                    var xdiff = cx - px;
                    var ydiff = cy - py;
                    length += Math.sqrt(xdiff * xdiff + ydiff * ydiff);
                }
                px = cx;
                py = cy;
            }
            return length;
        }
    }, {
        key: 'point',
        value: function point(t, start, c1, c2, end) {
            return start * (1.0 - t) * (1.0 - t) * (1.0 - t) + 3.0 * c1 * (1.0 - t) * (1.0 - t) * t + 3.0 * c2 * (1.0 - t) * t * t + end * t * t * t;
        }
    }], [{
        key: 'fromPoints',
        value: function fromPoints(points, widths) {
            var c2 = this.calculateControlPoints(points[0], points[1], points[2]).c2;
            var c3 = this.calculateControlPoints(points[1], points[2], points[3]).c1;
            return new Bezier(points[1], c2, c3, points[2], widths.start, widths.end);
        }
    }, {
        key: 'calculateControlPoints',
        value: function calculateControlPoints(s1, s2, s3) {
            var dx1 = s1.x - s2.x;
            var dy1 = s1.y - s2.y;
            var dx2 = s2.x - s3.x;
            var dy2 = s2.y - s3.y;
            var m1 = { x: (s1.x + s2.x) / 2.0, y: (s1.y + s2.y) / 2.0 };
            var m2 = { x: (s2.x + s3.x) / 2.0, y: (s2.y + s3.y) / 2.0 };
            var l1 = Math.sqrt(dx1 * dx1 + dy1 * dy1);
            var l2 = Math.sqrt(dx2 * dx2 + dy2 * dy2);
            var dxm = m1.x - m2.x;
            var dym = m1.y - m2.y;
            var k = l2 / (l1 + l2);
            var cm = { x: m2.x + dxm * k, y: m2.y + dym * k };
            var tx = s2.x - cm.x;
            var ty = s2.y - cm.y;
            return {
                c1: new Point(m1.x + tx, m1.y + ty),
                c2: new Point(m2.x + tx, m2.y + ty)
            };
        }
    }]);

    return Bezier;
}();

function throttle(fn) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;

    var previous = 0;
    var timeout = null;
    var result = void 0;
    var storedContext = void 0;
    var storedArgs = void 0;
    var later = function later() {
        previous = Date.now();
        timeout = null;
        result = fn.apply(storedContext, storedArgs);
        if (!timeout) {
            storedContext = null;
            storedArgs = [];
        }
    };
    return function wrapper() {
        var now = Date.now();
        var remaining = wait - (now - previous);
        storedContext = this;

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        storedArgs = args;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            previous = now;
            result = fn.apply(storedContext, storedArgs);
            if (!timeout) {
                storedContext = null;
                storedArgs = [];
            }
        } else if (!timeout) {
            timeout = window.setTimeout(later, remaining);
        }
        return result;
    };
}

var SignaturePad = function () {
    function SignaturePad(canvas) {
        var _this = this;

        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        _classCallCheck(this, SignaturePad);

        this.canvas = canvas;
        this.options = options;
        this._handleMouseDown = function (event) {
            if (event.which === 1) {
                _this._mouseButtonDown = true;
                _this._strokeBegin(event);
            }
        };
        this._handleMouseMove = function (event) {
            if (_this._mouseButtonDown) {
                _this._strokeMoveUpdate(event);
            }
        };
        this._handleMouseUp = function (event) {
            if (event.which === 1 && _this._mouseButtonDown) {
                _this._mouseButtonDown = false;
                _this._strokeEnd(event);
            }
        };
        this._handleTouchStart = function (event) {
            event.preventDefault();
            if (event.targetTouches.length === 1) {
                var touch = event.changedTouches[0];
                _this._strokeBegin(touch);
            }
        };
        this._handleTouchMove = function (event) {
            event.preventDefault();
            var touch = event.targetTouches[0];
            _this._strokeMoveUpdate(touch);
        };
        this._handleTouchEnd = function (event) {
            var wasCanvasTouched = event.target === _this.canvas;
            if (wasCanvasTouched) {
                event.preventDefault();
                var touch = event.changedTouches[0];
                _this._strokeEnd(touch);
            }
        };
        this.velocityFilterWeight = options.velocityFilterWeight || 0.7;
        this.minWidth = options.minWidth || 0.5;
        this.maxWidth = options.maxWidth || 2.5;
        this.throttle = 'throttle' in options ? options.throttle : 16;
        this.minDistance = 'minDistance' in options ? options.minDistance : 5;
        this.dotSize = options.dotSize || function dotSize() {
            return (this.minWidth + this.maxWidth) / 2;
        };
        this.penColor = options.penColor || 'black';
        this.backgroundColor = options.backgroundColor || 'rgba(0,0,0,0)';
        this.onBegin = options.onBegin;
        this.onEnd = options.onEnd;
        this._strokeMoveUpdate = this.throttle ? throttle(SignaturePad.prototype._strokeUpdate, this.throttle) : SignaturePad.prototype._strokeUpdate;
        this._ctx = canvas.getContext('2d');
        this.clear();
        this.on();
    }

    _createClass(SignaturePad, [{
        key: 'clear',
        value: function clear() {
            var ctx = this._ctx,
                canvas = this.canvas;

            ctx.fillStyle = this.backgroundColor;
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            ctx.fillRect(0, 0, canvas.width, canvas.height);
            this._data = [];
            this._reset();
            this._isEmpty = true;
        }
    }, {
        key: 'fromDataURL',
        value: function fromDataURL(dataUrl) {
            var _this2 = this;

            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var callback = arguments[2];

            var image = new Image();
            var ratio = options.ratio || window.devicePixelRatio || 1;
            var width = options.width || this.canvas.width / ratio;
            var height = options.height || this.canvas.height / ratio;
            this._reset();
            image.onload = function () {
                _this2._ctx.drawImage(image, 0, 0, width, height);
                if (callback) {
                    callback();
                }
            };
            image.onerror = function (error) {
                if (callback) {
                    callback(error);
                }
            };
            image.src = dataUrl;
            this._isEmpty = false;
        }
    }, {
        key: 'toDataURL',
        value: function toDataURL() {
            var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'image/png';
            var encoderOptions = arguments[1];

            switch (type) {
                case 'image/svg+xml':
                    return this._toSVG();
                default:
                    return this.canvas.toDataURL(type, encoderOptions);
            }
        }
    }, {
        key: 'on',
        value: function on() {
            this.canvas.style.touchAction = 'none';
            this.canvas.style.msTouchAction = 'none';
            if (window.PointerEvent) {
                this._handlePointerEvents();
            } else {
                this._handleMouseEvents();
                if ('ontouchstart' in window) {
                    this._handleTouchEvents();
                }
            }
        }
    }, {
        key: 'off',
        value: function off() {
            this.canvas.style.touchAction = 'auto';
            this.canvas.style.msTouchAction = 'auto';
            this.canvas.removeEventListener('pointerdown', this._handleMouseDown);
            this.canvas.removeEventListener('pointermove', this._handleMouseMove);
            document.removeEventListener('pointerup', this._handleMouseUp);
            this.canvas.removeEventListener('mousedown', this._handleMouseDown);
            this.canvas.removeEventListener('mousemove', this._handleMouseMove);
            document.removeEventListener('mouseup', this._handleMouseUp);
            this.canvas.removeEventListener('touchstart', this._handleTouchStart);
            this.canvas.removeEventListener('touchmove', this._handleTouchMove);
            this.canvas.removeEventListener('touchend', this._handleTouchEnd);
        }
    }, {
        key: 'isEmpty',
        value: function isEmpty() {
            return this._isEmpty;
        }
    }, {
        key: 'fromData',
        value: function fromData(pointGroups) {
            var _this3 = this;

            this.clear();
            this._fromData(pointGroups, function (_ref) {
                var color = _ref.color,
                    curve = _ref.curve;
                return _this3._drawCurve({ color: color, curve: curve });
            }, function (_ref2) {
                var color = _ref2.color,
                    point = _ref2.point;
                return _this3._drawDot({ color: color, point: point });
            });
            this._data = pointGroups;
        }
    }, {
        key: 'toData',
        value: function toData() {
            return this._data;
        }
    }, {
        key: '_strokeBegin',
        value: function _strokeBegin(event) {
            var newPointGroup = {
                color: this.penColor,
                points: []
            };
            if (typeof this.onBegin === 'function') {
                this.onBegin(event);
            }
            this._data.push(newPointGroup);
            this._reset();
            this._strokeUpdate(event);
        }
    }, {
        key: '_strokeUpdate',
        value: function _strokeUpdate(event) {
            if (this._data.length === 0) {
                this._strokeBegin(event);
                return;
            }
            var x = event.clientX;
            var y = event.clientY;
            var point = this._createPoint(x, y);
            var lastPointGroup = this._data[this._data.length - 1];
            var lastPoints = lastPointGroup.points;
            var lastPoint = lastPoints.length > 0 && lastPoints[lastPoints.length - 1];
            var isLastPointTooClose = lastPoint ? point.distanceTo(lastPoint) <= this.minDistance : false;
            var color = lastPointGroup.color;
            if (!lastPoint || !(lastPoint && isLastPointTooClose)) {
                var curve = this._addPoint(point);
                if (!lastPoint) {
                    this._drawDot({ color: color, point: point });
                } else if (curve) {
                    this._drawCurve({ color: color, curve: curve });
                }
                lastPoints.push({
                    time: point.time,
                    x: point.x,
                    y: point.y
                });
            }
        }
    }, {
        key: '_strokeEnd',
        value: function _strokeEnd(event) {
            this._strokeUpdate(event);
            if (typeof this.onEnd === 'function') {
                this.onEnd(event);
            }
        }
    }, {
        key: '_handlePointerEvents',
        value: function _handlePointerEvents() {
            this._mouseButtonDown = false;
            this.canvas.addEventListener('pointerdown', this._handleMouseDown);
            this.canvas.addEventListener('pointermove', this._handleMouseMove);
            document.addEventListener('pointerup', this._handleMouseUp);
        }
    }, {
        key: '_handleMouseEvents',
        value: function _handleMouseEvents() {
            this._mouseButtonDown = false;
            this.canvas.addEventListener('mousedown', this._handleMouseDown);
            this.canvas.addEventListener('mousemove', this._handleMouseMove);
            document.addEventListener('mouseup', this._handleMouseUp);
        }
    }, {
        key: '_handleTouchEvents',
        value: function _handleTouchEvents() {
            this.canvas.addEventListener('touchstart', this._handleTouchStart);
            this.canvas.addEventListener('touchmove', this._handleTouchMove);
            this.canvas.addEventListener('touchend', this._handleTouchEnd);
        }
    }, {
        key: '_reset',
        value: function _reset() {
            this._lastPoints = [];
            this._lastVelocity = 0;
            this._lastWidth = (this.minWidth + this.maxWidth) / 2;
            this._ctx.fillStyle = this.penColor;
        }
    }, {
        key: '_createPoint',
        value: function _createPoint(x, y) {
            var rect = this.canvas.getBoundingClientRect();
            return new Point(x - rect.left, y - rect.top, new Date().getTime());
        }
    }, {
        key: '_addPoint',
        value: function _addPoint(point) {
            var _lastPoints = this._lastPoints;

            _lastPoints.push(point);
            if (_lastPoints.length > 2) {
                if (_lastPoints.length === 3) {
                    _lastPoints.unshift(_lastPoints[0]);
                }
                var widths = this._calculateCurveWidths(_lastPoints[1], _lastPoints[2]);
                var curve = Bezier.fromPoints(_lastPoints, widths);
                _lastPoints.shift();
                return curve;
            }
            return null;
        }
    }, {
        key: '_calculateCurveWidths',
        value: function _calculateCurveWidths(startPoint, endPoint) {
            var velocity = this.velocityFilterWeight * endPoint.velocityFrom(startPoint) + (1 - this.velocityFilterWeight) * this._lastVelocity;
            var newWidth = this._strokeWidth(velocity);
            var widths = {
                end: newWidth,
                start: this._lastWidth
            };
            this._lastVelocity = velocity;
            this._lastWidth = newWidth;
            return widths;
        }
    }, {
        key: '_strokeWidth',
        value: function _strokeWidth(velocity) {
            return Math.max(this.maxWidth / (velocity + 1), this.minWidth);
        }
    }, {
        key: '_drawCurveSegment',
        value: function _drawCurveSegment(x, y, width) {
            var ctx = this._ctx;
            ctx.moveTo(x, y);
            ctx.arc(x, y, width, 0, 2 * Math.PI, false);
            this._isEmpty = false;
        }
    }, {
        key: '_drawCurve',
        value: function _drawCurve(_ref3) {
            var color = _ref3.color,
                curve = _ref3.curve;

            var ctx = this._ctx;
            var widthDelta = curve.endWidth - curve.startWidth;
            var drawSteps = Math.floor(curve.length()) * 2;
            ctx.beginPath();
            ctx.fillStyle = color;
            for (var i = 0; i < drawSteps; i += 1) {
                var t = i / drawSteps;
                var tt = t * t;
                var ttt = tt * t;
                var u = 1 - t;
                var uu = u * u;
                var uuu = uu * u;
                var x = uuu * curve.startPoint.x;
                x += 3 * uu * t * curve.control1.x;
                x += 3 * u * tt * curve.control2.x;
                x += ttt * curve.endPoint.x;
                var y = uuu * curve.startPoint.y;
                y += 3 * uu * t * curve.control1.y;
                y += 3 * u * tt * curve.control2.y;
                y += ttt * curve.endPoint.y;
                var width = Math.min(curve.startWidth + ttt * widthDelta, this.maxWidth);
                this._drawCurveSegment(x, y, width);
            }
            ctx.closePath();
            ctx.fill();
        }
    }, {
        key: '_drawDot',
        value: function _drawDot(_ref4) {
            var color = _ref4.color,
                point = _ref4.point;

            var ctx = this._ctx;
            var width = typeof this.dotSize === 'function' ? this.dotSize() : this.dotSize;
            ctx.beginPath();
            this._drawCurveSegment(point.x, point.y, width);
            ctx.closePath();
            ctx.fillStyle = color;
            ctx.fill();
        }
    }, {
        key: '_fromData',
        value: function _fromData(pointGroups, drawCurve, drawDot) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = pointGroups[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var group = _step.value;
                    var color = group.color,
                        points = group.points;

                    if (points.length > 1) {
                        for (var j = 0; j < points.length; j += 1) {
                            var basicPoint = points[j];
                            var point = new Point(basicPoint.x, basicPoint.y, basicPoint.time);
                            this.penColor = color;
                            if (j === 0) {
                                this._reset();
                            }
                            var curve = this._addPoint(point);
                            if (curve) {
                                drawCurve({ color: color, curve: curve });
                            }
                        }
                    } else {
                        this._reset();
                        drawDot({
                            color: color,
                            point: points[0]
                        });
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    }, {
        key: '_toSVG',
        value: function _toSVG() {
            var _this4 = this;

            var pointGroups = this._data;
            var ratio = Math.max(window.devicePixelRatio || 1, 1);
            var minX = 0;
            var minY = 0;
            var maxX = this.canvas.width / ratio;
            var maxY = this.canvas.height / ratio;
            var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            svg.setAttribute('width', this.canvas.width.toString());
            svg.setAttribute('height', this.canvas.height.toString());
            this._fromData(pointGroups, function (_ref5) {
                var color = _ref5.color,
                    curve = _ref5.curve;

                var path = document.createElement('path');
                if (!isNaN(curve.control1.x) && !isNaN(curve.control1.y) && !isNaN(curve.control2.x) && !isNaN(curve.control2.y)) {
                    var attr = 'M ' + curve.startPoint.x.toFixed(3) + ',' + curve.startPoint.y.toFixed(3) + ' ' + ('C ' + curve.control1.x.toFixed(3) + ',' + curve.control1.y.toFixed(3) + ' ') + (curve.control2.x.toFixed(3) + ',' + curve.control2.y.toFixed(3) + ' ') + (curve.endPoint.x.toFixed(3) + ',' + curve.endPoint.y.toFixed(3));
                    path.setAttribute('d', attr);
                    path.setAttribute('stroke-width', (curve.endWidth * 2.25).toFixed(3));
                    path.setAttribute('stroke', color);
                    path.setAttribute('fill', 'none');
                    path.setAttribute('stroke-linecap', 'round');
                    svg.appendChild(path);
                }
            }, function (_ref6) {
                var color = _ref6.color,
                    point = _ref6.point;

                var circle = document.createElement('circle');
                var dotSize = typeof _this4.dotSize === 'function' ? _this4.dotSize() : _this4.dotSize;
                circle.setAttribute('r', dotSize.toString());
                circle.setAttribute('cx', point.x.toString());
                circle.setAttribute('cy', point.y.toString());
                circle.setAttribute('fill', color);
                svg.appendChild(circle);
            });
            var prefix = 'data:image/svg+xml;base64,';
            var header = '<svg' + ' xmlns="http://www.w3.org/2000/svg"' + ' xmlns:xlink="http://www.w3.org/1999/xlink"' + (' viewBox="' + minX + ' ' + minY + ' ' + maxX + ' ' + maxY + '"') + (' width="' + maxX + '"') + (' height="' + maxY + '"') + '>';
            var body = svg.innerHTML;
            if (body === undefined) {
                var dummy = document.createElement('dummy');
                var nodes = svg.childNodes;
                dummy.innerHTML = '';
                for (var i = 0; i < nodes.length; i += 1) {
                    dummy.appendChild(nodes[i].cloneNode(true));
                }
                body = dummy.innerHTML;
            }
            var footer = '</svg>';
            var data = header + body + footer;
            return prefix + btoa(data);
        }
    }]);

    return SignaturePad;
}();

/* harmony default export */ __webpack_exports__["a"] = (SignaturePad);
//# sourceMappingURL=signature_pad.js.map

/***/ }),

/***/ 136:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"signature-container",style:(("width: " + _vm.width + "px; height: " + _vm.height + "px;"))},[_c('div',{staticClass:"safe-area",style:(("margin: 0 " + (_vm.safeArea[0]) + "px " + (_vm.safeArea[1]) + "px " + (_vm.safeArea[0]) + "px;"))}),_vm._v(" "),_c('canvas',{ref:"signature"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 137:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"widget widget--dobrodelen"},[_c('div',{class:{ widget__blurred: _vm.shouldShowSignatureForm }},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"widget__content__container"},[_c('div',{staticClass:"widget__content"},[_c('div',{staticClass:"widget__ngo"},[_c('h2',[_vm._v("Podatki o upravičencu")]),_vm._v(" "),_c('div',{staticClass:"widget__form"},[_c('div',{staticClass:"form-controls row"},[_c('div',{staticClass:"col-xs-12"},[_c('input',{staticClass:"form-control",attrs:{"readonly":""},domProps:{"value":_vm.name}})]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('input',{staticClass:"form-control",attrs:{"readonly":""},domProps:{"value":_vm.address}})]),_vm._v(" "),_c('div',{staticClass:"col-xs-4"},[_c('input',{staticClass:"form-control",attrs:{"readonly":""},domProps:{"value":_vm.postalCode}})]),_vm._v(" "),_c('div',{staticClass:"col-xs-8"},[_c('input',{staticClass:"form-control",attrs:{"readonly":""},domProps:{"value":_vm.city}})]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"form-inline-container"},[_c('div',{staticClass:"form-inline"},[_c('label',{staticClass:"tax-label"},[_vm._v("Davčna številka")]),_vm._v(" "),_c('div',{staticClass:"control-container control-container--tax"},[_c('input',{staticClass:"form-control",attrs:{"maxlength":"1","readonly":""},domProps:{"value":_vm.taxNumberArray[0]}}),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"maxlength":"1","readonly":""},domProps:{"value":_vm.taxNumberArray[1]}}),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"maxlength":"1","readonly":""},domProps:{"value":_vm.taxNumberArray[2]}}),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"maxlength":"1","readonly":""},domProps:{"value":_vm.taxNumberArray[3]}}),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"maxlength":"1","readonly":""},domProps:{"value":_vm.taxNumberArray[4]}}),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"maxlength":"1","readonly":""},domProps:{"value":_vm.taxNumberArray[5]}}),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"maxlength":"1","readonly":""},domProps:{"value":_vm.taxNumberArray[6]}}),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"maxlength":"1","readonly":""},domProps:{"value":_vm.taxNumberArray[7]}})])]),_vm._v(" "),_c('div',{staticClass:"form-inline"},[_c('label',{staticClass:"percent-label"},[_vm._v("Odstotek")]),_vm._v(" "),_c('div',{staticClass:"control-container control-container--percent"},[_c('input',{staticClass:"form-control",attrs:{"readonly":""},domProps:{"value":_vm.percent === '1.0' ? '1' : _vm.percent}})])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"widget__content"},[_c('div',{staticClass:"widget__person"},[_c('h2',[_vm._v("Podatki o davčnem zavezancu")]),_vm._v(" "),_c('div',{staticClass:"widget__form"},[_c('div',{staticClass:"form-controls row"},[_c('div',{staticClass:"col-xs-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.input.name),expression:"input.name"}],staticClass:"form-control",attrs:{"placeholder":"Ime oz. naziv upravičenca"},domProps:{"value":(_vm.input.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.input, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.input.address),expression:"input.address"}],staticClass:"form-control",attrs:{"placeholder":"Naselje, ulica, hišna številka"},domProps:{"value":(_vm.input.address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.input, "address", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-xs-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.input.postalCode),expression:"input.postalCode"}],staticClass:"form-control",attrs:{"placeholder":"Poštna št."},domProps:{"value":(_vm.input.postalCode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.input, "postalCode", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-xs-8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.input.city),expression:"input.city"}],staticClass:"form-control",attrs:{"placeholder":"Pošta"},domProps:{"value":(_vm.input.city)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.input, "city", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 form-inline"},[_c('label',[_vm._v("Davčna številka")]),_vm._v(" "),_c('div',{staticClass:"control-container control-container--tax"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.input.taxArray[0]),expression:"input.taxArray[0]"}],staticClass:"form-control",attrs:{"maxlength":"1"},domProps:{"value":(_vm.input.taxArray[0])},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.input.taxArray, 0, $event.target.value)},_vm.focusNext]}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.input.taxArray[1]),expression:"input.taxArray[1]"}],staticClass:"form-control",attrs:{"maxlength":"1"},domProps:{"value":(_vm.input.taxArray[1])},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.input.taxArray, 1, $event.target.value)},_vm.focusNext]}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.input.taxArray[2]),expression:"input.taxArray[2]"}],staticClass:"form-control",attrs:{"maxlength":"1"},domProps:{"value":(_vm.input.taxArray[2])},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.input.taxArray, 2, $event.target.value)},_vm.focusNext]}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.input.taxArray[3]),expression:"input.taxArray[3]"}],staticClass:"form-control",attrs:{"maxlength":"1"},domProps:{"value":(_vm.input.taxArray[3])},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.input.taxArray, 3, $event.target.value)},_vm.focusNext]}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.input.taxArray[4]),expression:"input.taxArray[4]"}],staticClass:"form-control",attrs:{"maxlength":"1"},domProps:{"value":(_vm.input.taxArray[4])},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.input.taxArray, 4, $event.target.value)},_vm.focusNext]}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.input.taxArray[5]),expression:"input.taxArray[5]"}],staticClass:"form-control",attrs:{"maxlength":"1"},domProps:{"value":(_vm.input.taxArray[5])},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.input.taxArray, 5, $event.target.value)},_vm.focusNext]}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.input.taxArray[6]),expression:"input.taxArray[6]"}],staticClass:"form-control",attrs:{"maxlength":"1"},domProps:{"value":(_vm.input.taxArray[6])},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.input.taxArray, 6, $event.target.value)},_vm.focusNext]}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.input.taxArray[7]),expression:"input.taxArray[7]"}],staticClass:"form-control",attrs:{"maxlength":"1"},domProps:{"value":(_vm.input.taxArray[7])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.input.taxArray, 7, $event.target.value)}}})])]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-xs-6"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.input.email),expression:"input.email"}],staticClass:"form-control",attrs:{"placeholder":"Elektronski naslov"},domProps:{"value":(_vm.input.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.input, "email", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-xs-6"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.input.phone),expression:"input.phone"}],staticClass:"form-control",attrs:{"placeholder":"Telefonska številka"},domProps:{"value":(_vm.input.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.input, "phone", $event.target.value)}}})])])]),_vm._v(" "),_c('p',{staticClass:"widget__text-small",staticStyle:{"margin-top":"10px","margin-bottom":"0"}})])])]),_vm._v(" "),_c('div',{staticClass:"widget__footer"},[_c('div',{staticClass:"widget__content__container"},[_c('div',{staticClass:"widget__content"},[_c('p',{staticClass:"widget__text-small"},[_vm._v("\n            Ko boste izpolnili obrazec, imate dve možnosti:\n          ")]),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{staticClass:"widget__buttons-container"},[_c('div',{staticClass:"widget__button-container"},[_c('a',{staticClass:"btn btn-primary btn-sm",attrs:{"href":_vm.linkToPDF,"download":"obrazec_enprocent.pdf","target":"_blank","disabled":_vm.inputHasErrors},on:{"click":_vm.onLinkToPDFClick}},[_c('i',{staticClass:"glyphicon glyphicon-download-alt"}),_vm._v(" Prenesi in pošlji obrazec sam\n              ")])]),_vm._v(" "),_c('div',{staticClass:"widget__button-container"},[(_vm.showSendToCnvosButton)?_c('button',{staticClass:"btn btn-primary btn-sm",attrs:{"download":"obrazec_enprocent.pdf","target":"_blank","disabled":_vm.inputHasErrors},on:{"click":function($event){$event.preventDefault();_vm.showSignatureForm($event)}}},[_c('i',{staticClass:"glyphicon glyphicon-pencil"}),_vm._v(" Podpiši in posreduj CNVOS-u\n              ")]):_vm._e()])])])])])]),_vm._v(" "),(_vm.shouldShowSignatureForm)?_c('div',{staticClass:"widget__overlay"},[_c('div',{staticClass:"widget__signature__content"},[(!_vm.signedPdfSubmitted)?[_c('signature-pad',{key:_vm.signaturePadKey,on:{"ready":_vm.onSignatureReady,"change":_vm.onSignatureChange}}),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-link btn-sm",staticStyle:{"padding":"0"},attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.resetSignature($event)}}},[_vm._v("Izbriši podpis")])]),_vm._v(" "),_c('div',{staticClass:"widget__signature__button"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":_vm.signatureFormHasErrors || _vm.pdfSubmitting},on:{"click":function($event){$event.preventDefault();_vm.onSubmitPDF($event)}}},[_vm._v("\n            Potrdi in posreduj obrazec CNVOS-u\n          ")])])]:[_vm._m(4)]],2)]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"widget__header"},[_c('h1',[_vm._v("Nič vas ne stane, če ste "),_c('span',[_vm._v("dobrodelni")]),_vm._v(".")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"widget__content__container"},[_c('div',{staticClass:"widget__content pb-0"},[_c('h2',[_vm._v("Zahteva za namenitev dela dohodnine za donacije")]),_vm._v(" "),_c('p',{staticClass:"widget__text-small mb-0"},[_vm._v("\n          Vsi davčni zavezanci imate možnost odločanja o svoji dohodnini. "),_c('strong',[_vm._v("Do 1 %")]),_vm._v(" lahko namenite eni izmed organizacij s seznama\n          upravičencev do donacije dohodnine.\n        ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-12 form-inline"},[_c('label',[_vm._v("Kontaktni podatki")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',{staticClass:"widget__text-small"},[_c('li',[_vm._v("\n              Če želite podatke sami posredovati Fursu, boste prejeli PDF datoteko. To natisnete in posredujete Fursu. V tem primeru ne shranjujemo\n              nobenih vaših podatkov.\n            ")]),_vm._v(" "),_c('li',[_vm._v("\n              Lahko pa vse uredite elektronsko ter tiskanje in pošiljanje prepustite CNVOS. Obrazce bodo posredovali Fursu vsakega 28. v mesecu, razen\n              decembra že 20. v mesecu. CNVOS bo vaše podatke izbrisal dan po tem, ko bodo vaš obrazec poslali Fursu. Več o splošnih pogojih uporabe in\n              obdelavi osebnih podatkov pri CNVOS si preberite "),_c('a',{attrs:{"href":"https://www.cnvos.si/nvo-vseved/enprocent/splosni-pogoji/","target":"_blank"}},[_vm._v("tukaj")]),_vm._v(".\n            ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"text-center",staticStyle:{"margin-top":"3rem","font-weight":"700"}},[_vm._v("\n          Hvala, prejeli smo vaš obrazec. Če imate kakršna koli vprašanja, nam pišite na "),_c('a',{attrs:{"href":"mailto:info@cnvos.si","target":"_blank"}},[_vm._v("info@cnvos.si")]),_vm._v(".\n        ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 14:
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(18)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),

/***/ 18:
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 35:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchDropdown_vue__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea91c3ca_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchDropdown_vue__ = __webpack_require__(39);
function injectStyle (ssrContext) {
  __webpack_require__(36)
}
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchDropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea91c3ca_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchDropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 36:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(37);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(14)("19ed656e", content, true, {});

/***/ }),

/***/ 37:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(13)(undefined);
// imports


// module
exports.push([module.i, "@-webkit-keyframes linkUnderlineAnimation{0%{background-size:100% 100%,0 100%}25%{background-size:50% 100%,0 100%}50%{background-size:0 100%,0 100%}75%{background-size:0 100%,50% 100%}to{background-size:0 100%,100% 100%}}@keyframes linkUnderlineAnimation{0%{background-size:100% 100%,0 100%}25%{background-size:50% 100%,0 100%}50%{background-size:0 100%,0 100%}75%{background-size:0 100%,50% 100%}to{background-size:0 100%,100% 100%}}.search-dropdown{border:1px solid #88acc3;position:relative}.search-dropdown:after{content:\"\";pointer-events:none;right:10px;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='xMinYMid' viewBox='0 0 32 32'%3E%3Cpath d='M21.3 29.4L7.9 16 21.3 2.6l2.8 2.8L13.5 16l10.6 10.6z' fill='%2388acc3'/%3E%3C/svg%3E\");background-repeat:no-repeat;background-position:50%;background-size:auto 20px;-webkit-transform:rotate(270deg);-ms-transform:rotate(270deg);transform:rotate(270deg)}.search-dropdown-clear,.search-dropdown:after{width:20px;height:20px;position:absolute;top:calc(50% - 10px)}.search-dropdown-clear{font-size:25px;line-height:20px;cursor:pointer;color:#88acc3;text-align:center;right:36px}.search-dropdown-input{background:#fff;border:none;font-size:.875rem;line-height:17px;outline:none;padding:8px 56px 8px 12px;width:100%}.search-dropdown-input::-webkit-input-placeholder{color:#000}.search-dropdown-input::-moz-placeholder{color:#000}.search-dropdown-input::-ms-input-placeholder{color:#000}.search-dropdown-input::placeholder{color:#000}.search-dropdown-options{background:#fff;border-left:1px solid #88acc3;border-bottom:1px solid #88acc3;border-right:1px solid #88acc3;display:none;position:absolute;left:-1px;top:34px;width:calc(100% + 2px);max-height:230px;list-style:none;margin:0;padding:0;overflow-y:auto;z-index:3}.search-dropdown-options.visible{display:block}.search-dropdown-options li{cursor:pointer;display:-webkit-box;display:-ms-flexbox;display:flex;font-size:.875rem;height:23px;line-height:23px;padding:0 12px;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.search-dropdown-options li.search-dropdown-group-label{background:#ededed;cursor:default;text-transform:uppercase}.search-dropdown-options li.focused{background:#f3f7f9}.search-dropdown-options li.selected{background-color:#88acc3;color:#fff}.search-dropdown-options li.selected.focused{background-color:#e7eef3}.search-dropdown-options li:not(:last-of-type):not(.selected):after{content:\"\";background-color:#e7eef3;height:1px;width:calc(100% - 24px);position:absolute;left:12px;bottom:0}.search-dropdown-options li .search-dropdown-label{-webkit-box-flex:1;-ms-flex:1 1;flex:1 1;margin-right:4px;overflow:hidden;-o-text-overflow:ellipsis;text-overflow:ellipsis;white-space:nowrap}.search-dropdown ::-webkit-scrollbar{width:4px;height:4px}.search-dropdown ::-webkit-scrollbar-track{background:#b0c8d8;border-radius:0}.search-dropdown ::-webkit-scrollbar-thumb{background:#5a84a0;border-radius:0}", ""]);

// exports


/***/ }),

/***/ 38:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var ITEM_HEIGHT = 23;
var ITEM_COUNT = 10;
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      filter: '',
      active: false,
      focused: -1
    };
  },
  watch: {
    filter: function filter() {
      this.focus(this.focused);
    }
  },
  computed: {
    filteredItems: function filteredItems() {
      var _this = this;

      var filterAndSort = function filterAndSort(items) {
        return items.filter(function (item) {
          return item.selected || item.label.toLowerCase().indexOf(_this.filter.toLowerCase()) > -1;
        }).map(function (item, index) {
          // eslint-disable-next-line no-param-reassign
          item.sortIndex = index;
          return item;
        }).sort(function (a, b) {
          if (!_this.single) {
            if (_this.alphabetise && Boolean(a.selected) === Boolean(b.selected)) {
              return a.label.localeCompare(b.label, 'sl');
            }
            if (a.selected && !b.selected) return -1;else if (!a.selected && b.selected) return 1;
          }
          if (a.sortIndex < b.sortIndex) return -1;else if (a.sortIndex > b.sortIndex) return 1;
          return 0;
        }).map(function (item) {
          // eslint-disable-next-line no-param-reassign
          delete item.sortIndex;
          return item;
        });
      };
      if (this.groups) {
        return this.groups.map(function (group) {
          var itemsFromGroup = filterAndSort(_this.items.filter(function (item) {
            return group.items.indexOf(item.id) > -1;
          }));
          itemsFromGroup.forEach(function (item, index) {
            // eslint-disable-next-line no-param-reassign
            item.groupLabel = index === 0 ? group.label : null;
          });
          return itemsFromGroup;
        }).reduce(function (a, b) {
          return a.concat(b);
        }, []);
      }
      return filterAndSort(this.items);
    },
    selectedIds: function selectedIds() {
      return this.filteredItems.filter(function (item) {
        return item.selected;
      }).map(function (item) {
        return item.id;
      });
    },
    adjustedPlaceholder: function adjustedPlaceholder() {
      if (!this.single) {
        return this.placeholder;
      }
      var selectedItem = this.filteredItems.filter(function (item) {
        return item.selected;
      })[0];
      return selectedItem ? selectedItem.label : this.placeholder;
    }
  },
  directives: {
    clickOutside: {
      bind: function bind(el, binding) {
        var handler = function handler(e) {
          if (!el.contains(e.target) && el !== e.target) {
            binding.value(e);
          }
        };
        el.vueClickOutside = handler; // eslint-disable-line no-param-reassign
        document.addEventListener('click', handler);
      },
      unbind: function unbind(el) {
        document.removeEventListener('click', el.vueClickOutside);
        el.vueClickOutside = null; // eslint-disable-line no-param-reassign
      }
    }
  },
  props: {
    items: { type: Array, required: true },
    placeholder: { type: String, required: true },
    groups: { type: Array, required: false },
    alphabetise: { type: Boolean, required: false, default: true },
    single: { type: Boolean, required: false }
  },
  methods: {
    selectItem: function selectItem(selectedItemId) {
      if (this.single) {
        this.clearSelection();
        this.toggleItem(selectedItemId);
        this.toggleDropdown(false);
        this.$emit('change', this.items.find(function (item) {
          return item.id === selectedItemId;
        }));
      } else {
        this.toggleItem(selectedItemId);
      }
    },
    toggleItem: function toggleItem(itemId) {
      var clickedItem = this.items.filter(function (item) {
        return item.id === itemId;
      })[0];
      this.$set(clickedItem, 'selected', !clickedItem.selected);
    },
    toggleDropdown: function toggleDropdown(state) {
      if (state === false) {
        this.filter = '';
      }
      this.active = state;
    },
    clearSelection: function clearSelection() {
      this.selectedIds.forEach(this.toggleItem);
    },
    focus: function focus(index, withKeyboard) {
      this.focused = Math.max(Math.min(this.filteredItems.length - 1, index), -1);
      if (!withKeyboard) return;
      var additionalOffset = this.filteredItems.slice(0, this.focused + 1).map(function (item) {
        return item.groupLabel ? 1 : 0;
      }).reduce(function (a, b) {
        return a + b;
      }, 0);
      var optionListEl = this.$el.lastChild;
      var focusedPosition = (this.focused + additionalOffset) * ITEM_HEIGHT;
      if (focusedPosition < optionListEl.scrollTop) {
        optionListEl.scrollTop = focusedPosition;
      } else if (focusedPosition > optionListEl.scrollTop + (ITEM_COUNT - 1) * ITEM_HEIGHT) {
        optionListEl.scrollTop = focusedPosition - (ITEM_COUNT - 1) * ITEM_HEIGHT;
      }
    }
  }
});

/***/ }),

/***/ 39:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(function() { _vm.toggleDropdown(false) }),expression:"function() { toggleDropdown(false) }"}],staticClass:"search-dropdown"},[(_vm.selectedIds.length > 0)?_c('div',{staticClass:"search-dropdown-clear",on:{"click":_vm.clearSelection}},[_vm._v("×")]):_vm._e(),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter),expression:"filter"}],staticClass:"search-dropdown-input",attrs:{"type":"text","placeholder":_vm.adjustedPlaceholder},domProps:{"value":(_vm.filter)},on:{"focus":function($event){_vm.toggleDropdown(true)},"keydown":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }$event.preventDefault();_vm.focused !== -1 && _vm.selectItem(_vm.filteredItems[_vm.focused].id)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"up",38,$event.key)){ return null; }$event.preventDefault();_vm.toggleDropdown(true), _vm.focus(_vm.focused - 1, true)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"down",40,$event.key)){ return null; }$event.preventDefault();_vm.toggleDropdown(true), _vm.focus(_vm.focused + 1, true)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"tab",9,$event.key)){ return null; }_vm.toggleDropdown(false)}],"input":[function($event){if($event.target.composing){ return; }_vm.filter=$event.target.value},function($event){_vm.toggleDropdown(true)}]}}),_vm._v(" "),_c('ul',{class:['search-dropdown-options', { visible: this.active }],on:{"mouseleave":function($event){_vm.focus(-1)}}},[_vm._l((_vm.filteredItems),function(item, index){return [(item.groupLabel)?_c('li',{staticClass:"search-dropdown-group-label"},[_vm._v("\n        "+_vm._s(item.groupLabel)+"\n      ")]):_vm._e(),_vm._v(" "),_c('li',{class:{ selected : item.selected, focused : _vm.focused === index },on:{"click":function($event){_vm.selectItem(item.id)},"mouseenter":function($event){_vm.focus(index)}}},[_c('div',{staticClass:"search-dropdown-label"},[_vm._v(_vm._s(item.label))]),_vm._v(" "),(item.count)?_c('div',[_vm._v(_vm._s(item.count))]):_vm._e()])]})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 392:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue__ = __webpack_require__(393);



var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App_vue__["a" /* default */]);
  }
});

window.app = app;

/***/ }),

/***/ 393:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_291e8bf9_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(398);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_291e8bf9_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 394:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_js_tooltip__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_js_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_bootstrap_js_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_js_transition__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_js_transition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_bootstrap_js_transition__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_js_collapse__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_js_collapse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_bootstrap_js_collapse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_query_string__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_copy_to_clipboard__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_copy_to_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_copy_to_clipboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_slider_component__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_slider_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_slider_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_SearchDropdown_vue__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__WidgetV2_vue__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__SignaturePad_vue__ = __webpack_require__(88);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













var MAX_SLIDER_SUM = 100;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  created: function created() {
    var _this = this;

    this.originalTitle = document.title;
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.getJSON('/enprocent/getDobrodelenAreas/').done(function (data) {
      _this.areas = data.areas;
      _this.loadFromUrl();
    });
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.getJSON('/enprocent/getDobrodelenKeys/').done(function (data) {
      // forsiraj izbiro "Društvo, zavod ali druga nepridobitna organizacija"
      data.pravne_oblike.forEach(function (po) {
        po.selected = po.id === '4';
      });
      //
      _this.dobrodelenKeysBecome = data;
      _this.loadFromUrl();
    });
  },
  data: function data() {
    return {
      isDragging: -1,
      sliderOptions: {
        interval: 10,
        piecewise: true,
        min: 0,
        max: MAX_SLIDER_SUM,
        height: 4,
        dotSize: 20,
        tooltip: 'never',
        speed: 0,
        class: 'slider slider--purple'
      },
      answer1: '',
      answer2: '',
      answer3: '',
      answer4: '',
      actualAnswer1: '',
      actualAnswer2: '',
      selected_orgs: [],
      selected_ratios: [],
      areas: [],
      findOrgResults: null,
      findOrgKeyword: null,
      findOrgTaxNumber: null,
      findOrgPostal: null,
      findOrgArea: null,
      findOrgLoading: false,
      selectedTooMany: false,
      showSelectRatios: false,
      shouldShowPersonInfoForm: false,
      shouldShowSignatureForm: false,
      signaturePadKey: 1,
      signatureFormHasErrors: true,
      signatureDataUrl: null,
      signedPdfSubmitted: false,
      personInfoForm: {
        name: '',
        address: '',
        postalCode: '',
        city: '',
        taxNumber: '',
        email: '',
        phone: ''
      },
      ngoInfoForm: {
        name: '',
        address: '',
        postalCode: '',
        city: '',
        taxNumber: '',
        percent: '1.0'
      },
      ngoInfoFormHasValidTaxNumber: false,
      ngoInfoFormTaxNumberNotFound: false,
      copiedWidgetCode: false,
      showingWidgetPreview: false,
      dobrodelenKeysBecome: false,
      originalTitle: null,
      becomeTitleText: null,
      becomeContentText: null,
      isLoadingFromUrl: false
    };
  },
  mounted: function mounted() {
    var _this2 = this;

    window.addEventListener('popstate', function (event) {
      _this2.onPopState(event.state);
    });
  },

  watch: {
    // answer3(value) {
    //   const map = {
    //     1: 'keyword',
    //     2: 'tax',
    //     3: 'postal',
    //     4: 'area',
    //   };
    //   if (value === '1' && this.findOrgKeyword) {
    //     this.fetchOrgResults(this.findOrgKeyword, map[value]);
    //   } else if (value === '2' && this.findOrgTaxNumber) {
    //     this.fetchOrgResults(this.findOrgTaxNumber, map[value]);
    //   } else if (value === '3' && this.findOrgPostal) {
    //     this.fetchOrgResults(this.findOrgPostal, map[value]);
    //   } else if (value === '4' && this.findOrgArea) {
    //     this.fetchOrgResults(this.findOrgArea, map[value]);
    //   }
    //   if (!this.isLoadingFromUrl) {
    //     this.trackContentInteraction('answer3', map[value]);
    //     // this.scrollTo('#find-org-radios');
    //     this.answer4 = '';
    //   }
    // },
    findOrgKeyword: function findOrgKeyword(value) {
      this.findOrgResults = null;
      this.findOrgLoading = true;
      this.fetchOrgResults(value, 'keyword');
    },
    findOrgTaxNumber: function findOrgTaxNumber(value) {
      this.findOrgResults = null;
      this.findOrgLoading = true;
      this.fetchOrgResults(value, 'tax');
    },
    findOrgPostal: function findOrgPostal(value) {
      this.findOrgResults = null;
      this.findOrgLoading = true;
      this.fetchOrgResults(value, 'postal');
    },
    findOrgArea: function findOrgArea(value) {
      this.findOrgResults = null;
      this.findOrgLoading = true;
      this.fetchOrgResults(value, 'area');
    },

    'personInfoForm.postalCode': function handler(newVal) {
      var _this3 = this;

      if (newVal && newVal.length === 4) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.getJSON('/enprocent/getFURS/' + newVal + '/').done(function (data) {
          _this3.personInfoForm.city = data.city;
        });
      }
    },
    'ngoInfoForm.postalCode': function handler(newVal) {
      var _this4 = this;

      if (newVal && newVal.length === 4) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.getJSON('/enprocent/getFURS/' + newVal + '/').done(function (data) {
          _this4.ngoInfoForm.city = data.city;
        });
      }
    },
    'ngoInfoForm.taxNumber': function handler(newVal) {
      var _this5 = this;

      this.ngoInfoFormHasValidTaxNumber = false;
      // this.ngoInfoFormTaxNumberNotFound = false;
      if (newVal && newVal.length === 8) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.getJSON('/enprocent/findNGOByTaxNumber/' + newVal + '/').done(function (data) {
          if (data && data.found) {
            _this5.ngoInfoForm.name = data.ngo.name;
            _this5.ngoInfoForm.address = data.ngo.address;
            _this5.ngoInfoForm.postalCode = data.ngo.postal_code;
            _this5.ngoInfoForm.city = data.ngo.city;
            _this5.ngoInfoFormTaxNumberNotFound = false;
            _this5.ngoInfoFormHasValidTaxNumber = true;
          } else {
            _this5.ngoInfoFormTaxNumberNotFound = true;
          }
        });
      }
    },
    legalFormSelected: function legalFormSelected() {
      var _this6 = this;

      if (this.dobrodelenKeysBecome && this.dobrodelenKeysBecome.vsebine) {
        this.dobrodelenKeysBecome.vsebine.forEach(function (e) {
          _this6.$set(e, 'selected', false);
        });
        // this.checkBecomeForm();
      }
    }
  },
  computed: {
    areasSelected: function areasSelected() {
      return this.areas.filter(function (e) {
        return e.selected;
      }).map(function (e) {
        return e.label;
      });
    },
    areasPlaceholder: function areasPlaceholder() {
      return this.areasSelected.length ? '' + this.areasSelected : 'Izberite področje dela';
    },
    areasOrgSelected: function areasOrgSelected() {
      if (this.areasOrgItems) {
        return this.areasOrgItems.filter(function (e) {
          return e.selected;
        });
      }
      return [];
    },
    areasOrgPlaceholder: function areasOrgPlaceholder() {
      return this.areasOrgSelected.length ? '' + this.areasOrgSelected[0].label : 'Področje dela';
    },
    areasOrgItems: function areasOrgItems() {
      var _this7 = this;

      if (this.dobrodelenKeysBecome && this.legalFormSelected.length) {
        return this.dobrodelenKeysBecome.vsebine.filter(function (e) {
          return e.pravna_oblika === _this7.legalFormSelected[0].id;
        });
      }
      return null;
    },
    legalFormSelected: function legalFormSelected() {
      if (this.dobrodelenKeysBecome) {
        return this.dobrodelenKeysBecome.pravne_oblike.filter(function (e) {
          return e.selected;
        });
      }
      return [];
    },
    legalFormPlaceholder: function legalFormPlaceholder() {
      return this.legalFormSelected.length ? '' + this.legalFormSelected[0].label : 'Pravna oblika';
    },
    personInfoFormHasErrors: function personInfoFormHasErrors() {
      var _this8 = this;

      if (Object.keys(this.personInfoForm).some(function (e) {
        return !_this8.personInfoForm[e];
      })) {
        return true;
      }
      if (this.personInfoForm.name.trim().length < 3 || this.personInfoForm.name.trim().indexOf(' ') === -1) {
        return true;
      }
      if (this.personInfoForm.address.trim().length < 3) {
        return true;
      }
      if (!/^\d{4}$/.test(this.personInfoForm.postalCode)) {
        return true;
      }
      if (this.personInfoForm.city.trim().length < 2) {
        return true;
      }
      if (!/^\d{8}$/.test(this.personInfoForm.taxNumber)) {
        return true;
      }
      var phone = this.personInfoForm.phone.replace(/\D/g, '');
      if (phone.length < 7) {
        return true;
      }
      if (!this.personInfoForm.email.includes('@') || !this.personInfoForm.email.includes('.')) {
        return true;
      }
      return false;
    },
    ngoInfoFormHasErrors: function ngoInfoFormHasErrors() {
      var _this9 = this;

      if (!this.ngoInfoFormHasValidTaxNumber) {
        return true;
      }
      // TODO: proper validation
      return Object.keys(this.ngoInfoForm).some(function (e) {
        return !_this9.ngoInfoForm[e];
      });
    },
    selectedOrgsForFormValue: function selectedOrgsForFormValue() {
      var _this10 = this;

      return this.selected_orgs.map(function (e, i) {
        return e.name + '|=|' + e.tax_number + '|=|' + _this10.selected_ratios[i] / 100;
      }).join('|-|');
    },
    showSendToCnvosButton: function showSendToCnvosButton() {
      var now = new Date();
      var month = now.getMonth() + 1;
      if (month === 12) {
        return now.getDate() < 21;
      }
      return true;
    }
  },
  methods: {
    resetStuff: function resetStuff() {
      var _this11 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.answer3 = '';
      this.answer4 = '';
      // this.legalFormSelected.forEach((e) => {
      //   this.$set(e, 'selected', state.legalForm ? e.label === state.legalForm : false);
      // });
      this.areas.forEach(function (e) {
        _this11.$set(e, 'selected', state.area ? e.label === state.area : false);
      });
      this.findOrgKeyword = null;
      this.findOrgTaxNumber = null;
      this.findOrgPostal = null;
      this.findOrgArea = null;
      this.findOrgResults = null;
      this.selected_orgs = [];
      this.selectedTooMany = false;
      this.selectedTooMany = false;
      this.showSelectRatios = false;
      this.shouldShowPersonInfoForm = false;
      this.shouldShowSignatureForm = false;
      this.signaturePadKey++;
      this.signatureFormHasErrors = true;
      this.signatureDataUrl = null;
      this.signedPdfSubmitted = false;
      this.ngoInfoForm = {
        name: '',
        address: '',
        postalCode: '',
        city: '',
        taxNumber: '',
        percent: '1.0'
      };
      this.personInfoForm = {
        name: '',
        address: '',
        postalCode: '',
        city: '',
        taxNumber: '',
        email: '',
        phone: ''
      };
    },
    onPopState: function onPopState(state) {
      if (state) {
        this.answer1 = state.answer1 || '';
        this.actualAnswer1 = state.actualAnswer1 || '';
        this.answer2 = state.answer2 || '';
        this.actualAnswer2 = state.actualAnswer2 || '';
        this.resetStuff(state);
      } else {
        this.answer1 = '';
        this.actualAnswer1 = '';
        this.answer2 = '';
        this.actualAnswer2 = '';
        this.resetStuff();
      }
      this.updateBreadcrumbs(window.location.href);
    },
    onNextAnswer1: function onNextAnswer1() {
      var _this12 = this;

      if (!this.isLoadingFromUrl && this.answer1) {
        // this.trackContentInteraction('answer1', newVal);
        this.$nextTick(function () {
          // this.scrollTo('#question-2');
          _this12.changeUrl(1);
        });
        this.actualAnswer1 = this.answer1;
        this.answer2 = '';
        this.resetStuff();
      }
    },
    onNextAnswer2: function onNextAnswer2(newVal) {
      var _this13 = this;

      if (!this.isLoadingFromUrl && this.answer2) {
        // this.trackContentInteraction('answer2', newVal);
        this.$nextTick(function () {
          // this.scrollTo('#question-3');
          // this.changeUrl(2);
          _this13.checkBecomeForm();
        });
        this.actualAnswer2 = this.answer2;
        this.resetStuff();
      }
    },

    fetchOrgResults: __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.debounce(function fetchOrgResults(value, field) {
      var _this14 = this;

      if (typeof value !== 'undefined' && value !== '') {
        var val = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isString(value) ? value.toUpperCase() : value;
        var url = field === 'area' ? '/enprocent/searchNGOsByArea/' + val + '/' : '/enprocent/searchNGOs/' + val + '/';
        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.getJSON(url + ('?f=' + field)).done(function (data) {
          var sortedData = data.slice().sort(function (a, b) {
            return a.name.localeCompare(b.name, 'sl');
          });
          _this14.findOrgResults = sortedData;
          _this14.findOrgLoading = false;
        });
      } else {
        this.findOrgResults = null;
        this.findOrgLoading = false;
      }
    }, 500),
    selectOrg: function selectOrg(org) {
      this.selectedTooMany = false;
      this.showSelectRatios = false;
      this.shouldShowPersonInfoForm = false;
      this.shouldShowSignatureForm = false;
      var index = this.selected_orgs.findIndex(function (e) {
        return e.id === org.id;
      });
      if (index !== -1) {
        this.selected_orgs.splice(index, 1);
        this.trackContentInteraction('un-selectOrg', org.name);
      } else if (this.selected_orgs.length >= 10) {
        this.selectedTooMany = true;
        this.trackContentInteraction('selectedTooMany', org.name);
      } else {
        this.selected_orgs.push(org);
        this.trackContentInteraction('selectOrg', org.name);
      }
    },
    isSelectedOrg: function isSelectedOrg(org) {
      return this.selected_orgs.find(function (e) {
        return e.id === org.id;
      }) != null;
    },
    selectRatios: function selectRatios() {
      var _this15 = this;

      this.trackContentInteraction('selectRatios', this.selected_orgs.length);
      this.answer4 = '';
      this.shouldShowPersonInfoForm = false;
      this.shouldShowSignatureForm = false;
      this.showSelectRatios = true;
      this.selected_ratios = Array(this.selected_orgs.length);
      for (var i = 0; i < this.selected_ratios.length; i += 1) {
        this.selected_ratios[i] = 0;
      }
      this.recalculateRatios();
      this.$nextTick(function () {
        _this15.scrollTo('#question-4');
      });
    },
    recalculateRatios: function recalculateRatios(index) {
      var ratios = this.selected_ratios;
      var step = 10;

      var sum = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.sum(ratios);
      if (index === undefined) {
        while (sum < MAX_SLIDER_SUM) {
          var lowestIndex = -1;
          for (var j = 0; j < ratios.length; j += 1) {
            if (ratios[j] < ratios[lowestIndex] || lowestIndex === -1) {
              lowestIndex = j;
            }
          }
          ratios[lowestIndex] += step;
          sum += step;
        }
      } else if (sum > MAX_SLIDER_SUM) {
        while (sum > MAX_SLIDER_SUM) {
          var highestIndex = -1;
          for (var _j = ratios.length - 1; _j >= 0; _j -= 1) {
            if (_j !== index) {
              if (ratios[_j] > ratios[highestIndex] || highestIndex === -1) {
                highestIndex = _j;
              }
            }
          }
          ratios[highestIndex] -= step;
          sum -= step;
        }
      } else if (sum < MAX_SLIDER_SUM) {
        while (sum < MAX_SLIDER_SUM) {
          var _lowestIndex = -1;
          for (var _j2 = 0; _j2 < ratios.length; _j2 += 1) {
            if (_j2 !== index) {
              if (ratios[_j2] < ratios[_lowestIndex] || _lowestIndex === -1) {
                _lowestIndex = _j2;
              }
            }
          }
          ratios[_lowestIndex] += step;
          sum += step;
        }
      }
    },
    continueToEdavki: function continueToEdavki() {
      var _this16 = this;

      this.trackContentInteraction('continueToEdavki', '');
      this.answer4 = 'edavki';
      this.shouldShowPersonInfoForm = false;
      this.shouldShowSignatureForm = false;
      this.showSelectRatios = false;
      this.$nextTick(function () {
        _this16.scrollTo('#question-4');
      });
    },
    showPersonInfoForm: function showPersonInfoForm() {
      var _this17 = this;

      this.trackContentInteraction('showPersonInfoForm', '');
      var removeIndexes = [];
      this.selected_ratios.forEach(function (ratio, index) {
        if (ratio <= 0) {
          removeIndexes.push(index);
        }
      });
      this.selected_orgs = this.selected_orgs.filter(function (o, i) {
        return removeIndexes.indexOf(i) === -1;
      });
      this.selected_ratios = this.selected_ratios.filter(function (o, i) {
        return removeIndexes.indexOf(i) === -1;
      });

      // TODO: proper validation
      this.shouldShowPersonInfoForm = true;
      this.shouldShowSignatureForm = false;
      this.$nextTick(function () {
        _this17.scrollTo('#question-5');
      });
    },
    showSignatureForm: function showSignatureForm() {
      var _this18 = this;

      this.shouldShowSignatureForm = true;
      this.$nextTick(function () {
        _this18.scrollTo('#question-6');
      });
    },
    onSignatureChange: function onSignatureChange(pad) {
      this.signatureFormHasErrors = pad.isEmpty();
      this.signatureDataUrl = pad.toDataURL();
    },
    onSignatureReady: function onSignatureReady(pad) {
      this.signatureFormHasErrors = true;
      this.signatureDataUrl = null;
      this.signedPdfSubmitted = false;
    },
    resetSignature: function resetSignature() {
      this.signaturePadKey++;
    },
    scrollTo: function scrollTo(selector) {
      if (this.isLoadingFromUrl) {
        return;
      }
      var offset = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(selector).offset();
      if (offset && offset.top) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('html, body').animate({
          scrollTop: offset.top
        }, 500);
      }
    },
    checkBecomeForm: function checkBecomeForm() {
      var _this19 = this;

      if (this.answer2 === 'become' && this.legalFormSelected.length && this.areasOrgSelected.length) {
        var legalForms = this.legalFormSelected;
        var areas = this.areasOrgSelected;
        var legalForm = legalForms.map(function (e) {
          return e.label;
        })[0];
        var area = areas.map(function (e) {
          return e.label;
        })[0];

        // this.trackContentInteraction('checkBecomeForm', `${legalForm} - ${area}`);

        var contentID = areas.map(function (e) {
          return e.id;
        })[0];

        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.getJSON('/enprocent/getDobrodelenContent/' + contentID + '/').done(function (data) {
          if (data.success) {
            _this19.becomeTitleText = data.title;
            _this19.becomeContentText = data.content;
            _this19.$nextTick(function () {
              // this.scrollTo('#question-4');
              _this19.changeUrl(3, legalForm, area);
              _this19.setNewTitle(_this19.becomeTitleText);
            });
          } else {
            _this19.becomeTitleText = '';
            _this19.becomeContentText = ':(';
          }
        });
      } else {
        this.changeUrl(2);
        this.setNewTitle();
      }
    },
    setNewTitle: function setNewTitle(newVal) {
      if (newVal) {
        document.title = newVal + ' - ' + this.originalTitle;
      } else {
        document.title = this.originalTitle;
      }
    },
    copyWidgetCode: function copyWidgetCode() {
      var _this20 = this;

      this.trackContentInteraction('copyWidgetCode', '');
      var qs = __WEBPACK_IMPORTED_MODULE_5_query_string___default.a.stringify(this.ngoInfoForm);
      var htmlCode = '';
      htmlCode += '<iframe id="enprocent_iframe" frameborder="0" width="800" height="600" style="max-width:100%;" src="https://www.cnvos.si/enprocent/embed/v2/?' + qs + '"></iframe>';
      htmlCode += '<script src="https://cdnjs.cloudflare.com/ajax/libs/iframe-resizer/4.3.2/iframeResizer.min.js"></' + 'script><script>iFrameResize({checkOrigin:false},\'#enprocent_iframe\');</' + 'script>';
      var copied = __WEBPACK_IMPORTED_MODULE_6_copy_to_clipboard___default()(htmlCode, { debug: true });
      if (copied) {
        this.copiedWidgetCode = true;
        setTimeout(function () {
          _this20.copiedWidgetCode = false;
        }, 3000);
      }
    },
    showWidgetPreview: function showWidgetPreview() {
      var _this21 = this;

      this.trackContentInteraction('showWidgetPreview', '');
      this.showingWidgetPreview = true;
      this.$nextTick(function () {
        _this21.scrollTo('#widget-preview');
      });
    },
    changeUrl: function changeUrl(limit, legalForm, area) {
      if (this.isLoadingFromUrl) {
        return;
      }
      var url = '/enprocent/';
      if (limit > 0) {
        if (this.answer1 === 'person') {
          url += 'posameznik/';
        } else if (this.answer1) {
          url += 'nvo/';
        }
      }
      if (limit > 1) {
        if (this.answer2 === 'edavki') {
          url += 'edavki/';
        } else if (this.answer2 === 'find_org') {
          url += 'poisci/';
        } else if (this.answer2 === 'become') {
          url += 'postani-upravicenec/';
        } else if (this.answer2) {
          url += 'gradnik/';
        }
      }
      if (limit > 2 && legalForm && area) {
        url += __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.kebabCase(legalForm) + '/' + __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.kebabCase(area);
      }
      if (window.history && window.history.pushState) {
        var newState = {
          answer1: this.answer1,
          actualAnswer1: this.actualAnswer1,
          answer2: this.answer2,
          actualAnswer2: this.actualAnswer2,
          legalForm: legalForm,
          area: area
        };
        window.history.pushState(newState, '', url);
        this.updateBreadcrumbs(url);
      }
    },
    updateBreadcrumbs: function updateBreadcrumbs(url) {
      if (url.startsWith('http')) {
        var urlObj = new URL(url);
        url = urlObj.pathname;
      }
      console.log('updateBreadcrumbs', url);

      var urlSplit = url.split('/').filter(function (e) {
        return e.length;
      });
      var rootPart = urlSplit[0];
      var urlParts = urlSplit.slice(1);
      var breadcrumbs = document.querySelector('.page-breadcrumbs');

      var extraItems = breadcrumbs.querySelectorAll('.dobrodelen-extra');
      extraItems.forEach(function (item) {
        item.remove();
      });

      var separator = breadcrumbs.querySelector('.page-breadcrumbs__separator');
      var lastItem = breadcrumbs.querySelector('.page-breadcrumbs__item:last-child');
      var lastItemText = lastItem ? lastItem.textContent.trim() : '';

      if (urlParts.length) {
        var span = lastItem.querySelector('span');
        if (span) {
          span.remove();
          var link = document.createElement('a');
          link.className = 'page-breadcrumbs__link';
          link.href = '/' + rootPart + '/';
          link.textContent = lastItemText;
          lastItem.appendChild(link);
        }
      } else {
        var _link = lastItem.querySelector('a');
        if (_link) {
          _link.remove();
          var _span = document.createElement('span');
          _span.className = 'page-breadcrumbs__current';
          _span.textContent = lastItemText;
          lastItem.appendChild(_span);
        }
      }

      urlParts.forEach(function (part, index) {
        var label = '';
        if (index === 0) {
          if (part === 'posameznik') {
            label = 'posameznik';
          } else if (part === 'nvo') {
            label = 'organizacija';
          }
        }
        if (index === 1) {
          if (part === 'edavki') {
            label = 'e-davki';
          } else if (part === 'poisci') {
            label = 'poišči organizacijo';
          } else if (part === 'postani-upravicenec') {
            label = 'postani upravičenec';
          } else if (part === 'gradnik') {
            label = 'gradnik za spletno stran';
          }
        }
        if (label) {
          var sep = separator.cloneNode(true);
          sep.className += ' dobrodelen-extra';
          breadcrumbs.appendChild(sep);

          var item = document.createElement('div');
          item.className = 'page-breadcrumbs__item dobrodelen-extra';
          if (index === urlParts.length - 1) {
            var _span2 = document.createElement('span');
            _span2.className = 'page-breadcrumbs__current';
            _span2.textContent = label;
            item.appendChild(_span2);
          } else {
            var _link2 = document.createElement('a');
            _link2.className = 'page-breadcrumbs__link';
            _link2.href = '/' + rootPart + '/' + urlParts.slice(0, index + 1).join('/') + '/';
            _link2.textContent = label;
            item.appendChild(_link2);
          }
          breadcrumbs.appendChild(item);
        }
      });
    },
    loadFromUrl: function loadFromUrl() {
      var _this22 = this;

      if (this.isLoadingFromUrl || !this.areas || !this.dobrodelenKeysBecome) {
        return;
      }
      var url = window.location.pathname;
      if (url && url.indexOf('/enprocent') === 0) {
        (function () {
          _this22.isLoadingFromUrl = true;
          var parts = url.split('/').filter(function (e) {
            return e.length;
          }).slice(1);

          var _loop = function _loop(i) {
            var part = parts[i];
            console.log(part, i);
            if (i === 0) {
              if (parts[i] === 'posameznik') {
                _this22.answer1 = 'person';
                _this22.actualAnswer1 = 'person';
              } else {
                _this22.answer1 = 'org';
                _this22.actualAnswer1 = 'org';
              }
            }
            if (i === 1) {
              if (parts[i] === 'edavki') {
                _this22.answer2 = 'edavki';
                _this22.actualAnswer2 = 'edavki';
              } else if (parts[i] === 'poisci') {
                _this22.answer2 = 'find_org';
                _this22.actualAnswer2 = 'find_org';
              } else if (parts[i] === 'postani-upravicenec') {
                _this22.answer2 = 'become';
                _this22.actualAnswer2 = 'become';
              } else {
                _this22.answer2 = 'plugin';
                _this22.actualAnswer2 = 'plugin';
              }
            }
            if (i === 2) {
              var legalForm = _this22.dobrodelenKeysBecome.pravne_oblike.find(function (e) {
                return parts[i] === __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.kebabCase(e.label);
              });
              if (legalForm) {
                _this22.$set(legalForm, 'selected', true);
              }
            }
            if (i === 3) {
              _this22.$nextTick(function () {
                _this22.isLoadingFromUrl = false;
                var area = _this22.areasOrgItems.find(function (e) {
                  return parts[i] === __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.kebabCase(e.label);
                });
                if (area) {
                  _this22.$set(area, 'selected', true);
                }
                _this22.$nextTick(function () {
                  _this22.checkBecomeForm();
                  _this22.isLoadingFromUrl = false;
                });
              });
            }
          };

          for (var i = 0; i < parts.length; i += 1) {
            _loop(i);
          }
          _this22.$nextTick(function () {
            _this22.$nextTick(function () {
              _this22.$nextTick(function () {
                _this22.isLoadingFromUrl = false;
                _this22.updateBreadcrumbs(window.location.href);
              });
            });
          });
        })();
      }
    },
    trackContentInteraction: function trackContentInteraction(contentName, contentPiece) {
      /* eslint-disable no-underscore-dangle */
      // window._paq = window._paq || [];
      // window._paq.push(['trackContentInteraction', 'nulapetClick', contentName, contentPiece, 'https://www.cnvos.si/enprocent/']);
      // trackContentInteraction(contentInteraction, contentName, contentPiece, contentTarget)
    },
    onSubmitPDF: function onSubmitPDF(event) {
      var _this23 = this;

      var form = event.target.closest('form');
      if (form) {
        var formData = new FormData(form);
        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
          url: form.action,
          data: formData,
          processData: false,
          contentType: false,
          type: 'POST',
          success: function success() {
            _this23.signedPdfSubmitted = true;
          }
        });
      }
    }
  },
  directives: {
    externallinks: function externallinks(el) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el).find('a[href^="http://"],a[href^="https://"]').attr('target', '_blank');
    },
    tooltips: function tooltips(el) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el).find('[data-toggle="tooltip"]').tooltip({
        container: 'body'
      });

      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el).find('.bootstrap-accordion-title').each(function fixCollapsedClass() {
        var $this = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
        var $body = $this.closest('.panel').find('.panel-collapse.collapse');
        $this.toggleClass('collapsed', !$body.hasClass('in'));
      });

      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el).find('[data-toggle="collapse"]').collapse();

      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el).find('.accordion-parent').on('show.bs.collapse', '.panel', function onShown() {
        var $panel = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).closest('.panel');
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('html, body').animate({
          scrollTop: $panel.offset().top
        }, {
          duration: 350,
          step: function step(now, tween) {
            tween.end = $panel.offset().top;
          }
        });
      });
    }
  },
  components: {
    VueSlider: __WEBPACK_IMPORTED_MODULE_7_vue_slider_component___default.a,
    SearchDropdown: __WEBPACK_IMPORTED_MODULE_8__components_SearchDropdown_vue__["a" /* default */],
    WidgetTwo: __WEBPACK_IMPORTED_MODULE_9__WidgetV2_vue__["a" /* default */],
    SignaturePad: __WEBPACK_IMPORTED_MODULE_10__SignaturePad_vue__["a" /* default */]
  }
});

/***/ }),

/***/ 395:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var deselectCurrent = __webpack_require__(396);

var defaultMessage = 'Copy to clipboard: #{key}, Enter';

function format(message) {
  var copyKey = (/mac os x/i.test(navigator.userAgent) ? '⌘' : 'Ctrl') + '+C';
  return message.replace(/#{\s*key\s*}/g, copyKey);
}

function copy(text, options) {
  var debug, message, reselectPrevious, range, selection, mark, success = false;
  if (!options) { options = {}; }
  debug = options.debug || false;
  try {
    reselectPrevious = deselectCurrent();

    range = document.createRange();
    selection = document.getSelection();

    mark = document.createElement('span');
    mark.textContent = text;
    // reset user styles for span element
    mark.style.all = 'unset';
    // prevents scrolling to the end of the page
    mark.style.position = 'fixed';
    mark.style.top = 0;
    mark.style.clip = 'rect(0, 0, 0, 0)';
    // used to preserve spaces and line breaks
    mark.style.whiteSpace = 'pre';
    // do not inherit user-select (it may be `none`)
    mark.style.webkitUserSelect = 'text';
    mark.style.MozUserSelect = 'text';
    mark.style.msUserSelect = 'text';
    mark.style.userSelect = 'text';

    document.body.appendChild(mark);

    range.selectNode(mark);
    selection.addRange(range);

    var successful = document.execCommand('copy');
    if (!successful) {
      throw new Error('copy command was unsuccessful');
    }
    success = true;
  } catch (err) {
    debug && console.error('unable to copy using execCommand: ', err);
    debug && console.warn('trying IE specific stuff');
    try {
      window.clipboardData.setData('text', text);
      success = true;
    } catch (err) {
      debug && console.error('unable to copy using clipboardData: ', err);
      debug && console.error('falling back to prompt');
      message = format('message' in options ? options.message : defaultMessage);
      window.prompt(message, text);
    }
  } finally {
    if (selection) {
      if (typeof selection.removeRange == 'function') {
        selection.removeRange(range);
      } else {
        selection.removeAllRanges();
      }
    }

    if (mark) {
      document.body.removeChild(mark);
    }
    reselectPrevious();
  }

  return success;
}

module.exports = copy;


/***/ }),

/***/ 396:
/***/ (function(module, exports) {


module.exports = function () {
  var selection = document.getSelection();
  if (!selection.rangeCount) {
    return function () {};
  }
  var active = document.activeElement;

  var ranges = [];
  for (var i = 0; i < selection.rangeCount; i++) {
    ranges.push(selection.getRangeAt(i));
  }

  switch (active.tagName.toUpperCase()) { // .toUpperCase handles XHTML
    case 'INPUT':
    case 'TEXTAREA':
      active.blur();
      break;

    default:
      active = null;
      break;
  }

  selection.removeAllRanges();
  return function () {
    selection.type === 'Caret' &&
    selection.removeAllRanges();

    if (!selection.rangeCount) {
      ranges.forEach(function(range) {
        selection.addRange(range);
      });
    }

    active &&
    active.focus();
  };
};


/***/ }),

/***/ 397:
/***/ (function(module, exports, __webpack_require__) {

!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define("vue-slider-component",[],e):"object"==typeof exports?exports["vue-slider-component"]=e():t["vue-slider-component"]=e()}(this,function(){return function(t){function e(s){if(i[s])return i[s].exports;var r=i[s]={i:s,l:!1,exports:{}};return t[s].call(r.exports,r,r.exports,e),r.l=!0,r.exports}var i={};return e.m=t,e.c=i,e.i=function(t){return t},e.d=function(t,i,s){e.o(t,i)||Object.defineProperty(t,i,{configurable:!1,enumerable:!0,get:s})},e.n=function(t){var i=t&&t.__esModule?function(){return t.default}:function(){return t};return e.d(i,"a",i),i},e.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},e.p="",e(e.s=2)}([function(t,e,i){i(7);var s=i(5)(i(1),i(6),null,null);t.exports=s.exports},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default={data:function(){return{flag:!1,size:0,currentValue:0,currentSlider:0,dotWidthVal:"number"==typeof this.dotWidth?this.dotWidth:this.dotSize,dotHeightVal:"number"==typeof this.dotHeight?this.dotHeight:this.dotSize}},props:{width:{type:[Number,String],default:"auto"},height:{type:[Number,String],default:6},data:{type:Array,default:null},dotSize:{type:Number,default:16},dotWidth:{type:Number,required:!1},dotHeight:{type:Number,required:!1},min:{type:Number,default:0},max:{type:Number,default:100},interval:{type:Number,default:1},show:{type:Boolean,default:!0},disabled:{type:Boolean,default:!1},piecewise:{type:Boolean,default:!1},tooltip:{type:[String,Boolean],default:"always"},eventType:{type:String,default:"auto"},direction:{type:String,default:"horizontal"},reverse:{type:Boolean,default:!1},lazy:{type:Boolean,default:!1},clickable:{type:Boolean,default:!0},speed:{type:Number,default:.5},realTime:{type:Boolean,default:!1},value:{type:[String,Number,Array],default:0},piecewiseLabel:{type:Boolean,default:!1},sliderStyle:[Array,Object],tooltipDir:[Array,String],formatter:[String,Function],piecewiseStyle:Object,piecewiseActiveStyle:Object,processStyle:Object,bgStyle:Object,tooltipStyle:[Array,Object],labelStyle:Object,labelActiveStyle:Object},computed:{flowDirection:function(){return"vue-slider-"+this.direction+(this.reverse?"-reverse":"")},tooltipDirection:function(){var t=this.tooltipDir||("vertical"===this.direction?"left":"top");return Array.isArray(t)?this.isRange?t:t[1]:this.isRange?[t,t]:t},tooltipStatus:function(){return"hover"===this.tooltip&&this.flag?"vue-slider-always":this.tooltip?"vue-slider-"+this.tooltip:""},tooltipClass:function(){return["vue-slider-tooltip-"+this.tooltipDirection,"vue-slider-tooltip"]},isDisabled:function(){return"none"===this.eventType||this.disabled},disabledClass:function(){return this.disabled?"vue-slider-disabled":""},isRange:function(){return Array.isArray(this.value)},slider:function(){return this.isRange?[this.$refs.dot0,this.$refs.dot1]:this.$refs.dot},minimum:function(){return this.data?0:this.min},val:{get:function(){return this.data?this.isRange?[this.data[this.currentValue[0]],this.data[this.currentValue[1]]]:this.data[this.currentValue]:this.currentValue},set:function(t){if(this.data)if(this.isRange){var e=this.data.indexOf(t[0]),i=this.data.indexOf(t[1]);e>-1&&i>-1&&(this.currentValue=[e,i])}else{var s=this.data.indexOf(t);s>-1&&(this.currentValue=s)}else this.currentValue=t}},currentIndex:function(){return this.isRange?this.data?this.currentValue:[(this.currentValue[0]-this.minimum)/this.spacing,(this.currentValue[1]-this.minimum)/this.spacing]:(this.currentValue-this.minimum)/this.spacing},indexRange:function(){return this.isRange?this.currentIndex:[0,this.currentIndex]},maximum:function(){return this.data?this.data.length-1:this.max},multiple:function(){var t=(""+this.interval).split(".")[1];return t?Math.pow(10,t.length):1},spacing:function(){return this.data?1:this.interval},total:function(){return this.data?this.data.length-1:(~~((this.maximum-this.minimum)*this.multiple)%(this.interval*this.multiple)!=0&&console.error("[Vue-slider warn]: Prop[interval] is illegal, Please make sure that the interval can be divisible"),(this.maximum-this.minimum)/this.interval)},gap:function(){return this.size/this.total},position:function(){return this.isRange?[(this.currentValue[0]-this.minimum)/this.spacing*this.gap,(this.currentValue[1]-this.minimum)/this.spacing*this.gap]:(this.currentValue-this.minimum)/this.spacing*this.gap},limit:function(){return this.isRange?[[0,this.position[1]],[this.position[0],this.size]]:[0,this.size]},valueLimit:function(){return this.isRange?[[this.minimum,this.currentValue[1]],[this.currentValue[0],this.maximum]]:[this.minimum,this.maximum]},wrapStyles:function(){return"vertical"===this.direction?{height:"number"==typeof this.height?this.height+"px":this.height,padding:this.dotHeightVal/2+"px "+this.dotWidthVal/2+"px"}:{width:"number"==typeof this.width?this.width+"px":this.width,padding:this.dotHeightVal/2+"px "+this.dotWidthVal/2+"px"}},sliderStyles:function(){return Array.isArray(this.sliderStyle)?this.isRange?this.sliderStyle:this.sliderStyle[1]:this.isRange?[this.sliderStyle,this.sliderStyle]:this.sliderStyle},tooltipStyles:function(){return Array.isArray(this.tooltipStyle)?this.isRange?this.tooltipStyle:this.tooltipStyle[1]:this.isRange?[this.tooltipStyle,this.tooltipStyle]:this.tooltipStyle},elemStyles:function(){return"vertical"===this.direction?{width:this.width+"px",height:"100%"}:{height:this.height+"px"}},dotStyles:function(){return"vertical"===this.direction?{width:this.dotWidthVal+"px",height:this.dotHeightVal+"px",left:-(this.dotWidthVal-this.width)/2+"px"}:{width:this.dotWidthVal+"px",height:this.dotHeightVal+"px",top:-(this.dotHeightVal-this.height)/2+"px"}},piecewiseDotStyle:function(){return"vertical"===this.direction?{width:this.width+"px",height:this.width+"px"}:{width:this.height+"px",height:this.height+"px"}},piecewiseDotWrap:function(){if(!this.piecewise&&!this.piecewiseLabel)return!1;for(var t=[],e=0;e<=this.total;e++){var i="vertical"===this.direction?{bottom:this.gap*e-this.width/2+"px",left:0}:{left:this.gap*e-this.height/2+"px",top:0},s=this.reverse?this.total-e:e,r=this.data?this.data[s]:this.spacing*s+this.min;t.push({style:i,label:this.formatter?this.formatting(r):r,inRange:s>=this.indexRange[0]&&s<=this.indexRange[1]})}return t}},watch:{value:function(t){this.flag||this.setValue(t,!0)},max:function(t){var e=this.limitValue(this.val);!1!==e&&this.setValue(e),this.refresh()},min:function(t){var e=this.limitValue(this.val);!1!==e&&this.setValue(e),this.refresh()},show:function(t){var e=this;t&&!this.size&&this.$nextTick(function(){e.refresh()})}},methods:{bindEvents:function(){document.addEventListener("touchmove",this.moving,{passive:!1}),document.addEventListener("touchend",this.moveEnd,{passive:!1}),document.addEventListener("mousemove",this.moving),document.addEventListener("mouseup",this.moveEnd),document.addEventListener("mouseleave",this.moveEnd),window.addEventListener("resize",this.refresh)},unbindEvents:function(){window.removeEventListener("resize",this.refresh),document.removeEventListener("touchmove",this.moving),document.removeEventListener("touchend",this.moveEnd),document.removeEventListener("mousemove",this.moving),document.removeEventListener("mouseup",this.moveEnd),document.removeEventListener("mouseleave",this.moveEnd)},formatting:function(t){return"string"==typeof this.formatter?this.formatter.replace(/\{value\}/,t):this.formatter(t)},getPos:function(t){return this.realTime&&this.getStaticData(),"vertical"===this.direction?this.reverse?t.pageY-this.offset:this.size-(t.pageY-this.offset):this.reverse?this.size-(t.clientX-this.offset):t.clientX-this.offset},wrapClick:function(t){if(this.isDisabled||!this.clickable)return!1;var e=this.getPos(t);this.isRange&&(this.currentSlider=e>(this.position[1]-this.position[0])/2+this.position[0]?1:0),this.setValueOnPos(e)},moveStart:function(t){if(this.isDisabled)return!1;this.isRange&&(this.currentSlider=t),this.flag=!0,this.$emit("drag-start",this)},moving:function(t){if(!this.flag)return!1;t.preventDefault(),t.targetTouches&&t.targetTouches[0]&&(t=t.targetTouches[0]),this.setValueOnPos(this.getPos(t),!0)},moveEnd:function(t){if(!this.flag)return!1;this.$emit("drag-end",this),this.lazy&&this.isDiff(this.val,this.value)&&this.syncValue(),this.flag=!1,this.setPosition()},setValueOnPos:function(t,e){var i=this.isRange?this.limit[this.currentSlider]:this.limit,s=this.isRange?this.valueLimit[this.currentSlider]:this.valueLimit;if(t>=i[0]&&t<=i[1]){this.setTransform(t);var r=(Math.round(t/this.gap)*(this.spacing*this.multiple)+this.minimum*this.multiple)/this.multiple;this.setCurrentValue(r,e)}else t<i[0]?(this.setTransform(i[0]),this.setCurrentValue(s[0]),1===this.currentSlider&&(this.currentSlider=0)):(this.setTransform(i[1]),this.setCurrentValue(s[1]),0===this.currentSlider&&(this.currentSlider=1))},isDiff:function(t,e){return Object.prototype.toString.call(t)!==Object.prototype.toString.call(e)||(Array.isArray(t)&&t.length===e.length?t.some(function(t,i){return t!==e[i]}):t!==e)},setCurrentValue:function(t,e){if(t<this.minimum||t>this.maximum)return!1;this.isRange?this.isDiff(this.currentValue[this.currentSlider],t)&&(this.currentValue.splice(this.currentSlider,1,t),this.lazy&&this.flag||this.syncValue()):this.isDiff(this.currentValue,t)&&(this.currentValue=t,this.lazy&&this.flag||this.syncValue()),e||this.setPosition()},setIndex:function(t){if(Array.isArray(t)&&this.isRange){var e=void 0;e=this.data?[this.data[t[0]],this.data[t[1]]]:[this.spacing*t[0]+this.minimum,this.spacing*t[1]+this.minimum],this.setValue(e)}else t=this.spacing*t+this.minimum,this.isRange&&(this.currentSlider=t>(this.currentValue[1]-this.currentValue[0])/2+this.currentValue[0]?1:0),this.setCurrentValue(t)},setValue:function(t,e,i){var s=this;if(this.isDiff(this.val,t)){var r=this.limitValue(t);this.val=!1!==r?this.isRange?r.concat():r:this.isRange?t.concat():t,this.syncValue(e)}this.$nextTick(function(){return s.setPosition(i)})},setPosition:function(t){this.flag||this.setTransitionTime(void 0===t?this.speed:t),this.isRange?(this.currentSlider=0,this.setTransform(this.position[this.currentSlider]),this.currentSlider=1,this.setTransform(this.position[this.currentSlider])):this.setTransform(this.position),this.flag||this.setTransitionTime(0)},setTransform:function(t){var e=("vertical"===this.direction?this.dotHeightVal/2-t:t-this.dotWidthVal/2)*(this.reverse?-1:1),i="vertical"===this.direction?"translateY("+e+"px)":"translateX("+e+"px)",s=(0===this.currentSlider?this.position[1]-t:t-this.position[0])+"px",r=(0===this.currentSlider?t:this.position[0])+"px";this.isRange?(this.slider[this.currentSlider].style.transform=i,this.slider[this.currentSlider].style.WebkitTransform=i,this.slider[this.currentSlider].style.msTransform=i,"vertical"===this.direction?(this.$refs.process.style.height=s,this.$refs.process.style[this.reverse?"top":"bottom"]=r):(this.$refs.process.style.width=s,this.$refs.process.style[this.reverse?"right":"left"]=r)):(this.slider.style.transform=i,this.slider.style.WebkitTransform=i,this.slider.style.msTransform=i,"vertical"===this.direction?(this.$refs.process.style.height=t+"px",this.$refs.process.style[this.reverse?"top":"bottom"]=0):(this.$refs.process.style.width=t+"px",this.$refs.process.style[this.reverse?"right":"left"]=0))},setTransitionTime:function(t){if(t||this.$refs.process.offsetWidth,this.isRange){for(var e=0;e<this.slider.length;e++)this.slider[e].style.transitionDuration=t+"s",this.slider[e].style.WebkitTransitionDuration=t+"s";this.$refs.process.style.transitionDuration=t+"s",this.$refs.process.style.WebkitTransitionDuration=t+"s"}else this.slider.style.transitionDuration=t+"s",this.slider.style.WebkitTransitionDuration=t+"s",this.$refs.process.style.transitionDuration=t+"s",this.$refs.process.style.WebkitTransitionDuration=t+"s"},limitValue:function(t){var e=this;if(this.data)return t;var i=!1;return this.isRange?t=t.map(function(t){return t<e.min?(i=!0,e.min):t>e.max?(i=!0,e.max):t}):t>this.max?(i=!0,t=this.max):t<this.min&&(i=!0,t=this.min),i&&t},syncValue:function(t){t||this.$emit("callback",this.val),this.$emit("input",this.isRange?this.val.concat():this.val)},getValue:function(){return this.val},getIndex:function(){return this.currentIndex},getStaticData:function(){this.$refs.elem&&(this.size="vertical"===this.direction?this.$refs.elem.offsetHeight:this.$refs.elem.offsetWidth,this.offset="vertical"===this.direction?this.$refs.elem.getBoundingClientRect().top+window.pageYOffset||document.documentElement.scrollTop:this.$refs.elem.getBoundingClientRect().left)},refresh:function(){this.$refs.elem&&(this.getStaticData(),this.setPosition())}},mounted:function(){var t=this;"undefined"!=typeof window&&"undefined"!=typeof document&&this.$nextTick(function(){t.getStaticData(),t.setValue(t.value,!0,0),t.bindEvents()})},beforeDestroy:function(){this.unbindEvents()}}},function(t,e,i){"use strict";var s=i(0);t.exports=s},function(t,e,i){e=t.exports=i(4)(),e.push([t.i,'.vue-slider-component{position:relative;-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.vue-slider-component.vue-slider-disabled{opacity:.5;cursor:not-allowed}.vue-slider-component.vue-slider-has-label{margin-bottom:15px}.vue-slider-component.vue-slider-disabled .vue-slider-dot{cursor:not-allowed}.vue-slider-component .vue-slider{position:relative;display:block;border-radius:15px;background-color:#ccc}.vue-slider-component .vue-slider:after{content:"";position:absolute;left:0;top:0;width:100%;height:100%;z-index:2}.vue-slider-component .vue-slider-process{position:absolute;border-radius:15px;background-color:#3498db;-webkit-transition:all 0s;transition:all 0s;z-index:1}.vue-slider-component.vue-slider-horizontal .vue-slider-process{width:0;height:100%;top:0;left:0;will-change:width}.vue-slider-component.vue-slider-vertical .vue-slider-process{width:100%;height:0;bottom:0;left:0;will-change:height}.vue-slider-component.vue-slider-horizontal-reverse .vue-slider-process{width:0;height:100%;top:0;right:0}.vue-slider-component.vue-slider-vertical-reverse .vue-slider-process{width:100%;height:0;top:0;left:0}.vue-slider-component .vue-slider-dot{position:absolute;border-radius:50%;background-color:#fff;-webkit-box-shadow:.5px .5px 2px 1px rgba(0,0,0,.32);box-shadow:.5px .5px 2px 1px rgba(0,0,0,.32);-webkit-transition:all 0s;transition:all 0s;will-change:transform;cursor:pointer;z-index:3}.vue-slider-component.vue-slider-horizontal .vue-slider-dot{left:0}.vue-slider-component.vue-slider-vertical .vue-slider-dot{bottom:0}.vue-slider-component.vue-slider-horizontal-reverse .vue-slider-dot{right:0}.vue-slider-component.vue-slider-vertical-reverse .vue-slider-dot{top:0}.vue-slider-component .vue-slider-tooltip-wrap{display:none;position:absolute;z-index:9}.vue-slider-component .vue-slider-tooltip{display:block;font-size:14px;white-space:nowrap;padding:2px 5px;min-width:20px;text-align:center;color:#fff;border-radius:5px;border:1px solid #3498db;background-color:#3498db}.vue-slider-component .vue-slider-tooltip-wrap.vue-slider-tooltip-top{top:-9px;left:50%;-webkit-transform:translate(-50%,-100%);transform:translate(-50%,-100%)}.vue-slider-component .vue-slider-tooltip-wrap.vue-slider-tooltip-bottom{bottom:-9px;left:50%;-webkit-transform:translate(-50%,100%);transform:translate(-50%,100%)}.vue-slider-component .vue-slider-tooltip-wrap.vue-slider-tooltip-left{top:50%;left:-9px;-webkit-transform:translate(-100%,-50%);transform:translate(-100%,-50%)}.vue-slider-component .vue-slider-tooltip-wrap.vue-slider-tooltip-right{top:50%;right:-9px;-webkit-transform:translate(100%,-50%);transform:translate(100%,-50%)}.vue-slider-component .vue-slider-tooltip-wrap.vue-slider-tooltip-top .vue-slider-tooltip:before{content:"";position:absolute;bottom:-10px;left:50%;width:0;height:0;border:5px solid transparent;border:6px solid transparent\\0;border-top-color:inherit;-webkit-transform:translate(-50%);transform:translate(-50%)}.vue-slider-component .vue-slider-tooltip-wrap.vue-slider-tooltip-bottom .vue-slider-tooltip:before{content:"";position:absolute;top:-10px;left:50%;width:0;height:0;border:5px solid transparent;border:6px solid transparent\\0;border-bottom-color:inherit;-webkit-transform:translate(-50%);transform:translate(-50%)}.vue-slider-component .vue-slider-tooltip-wrap.vue-slider-tooltip-left .vue-slider-tooltip:before{content:"";position:absolute;top:50%;right:-10px;width:0;height:0;border:5px solid transparent;border:6px solid transparent\\0;border-left-color:inherit;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.vue-slider-component .vue-slider-tooltip-wrap.vue-slider-tooltip-right .vue-slider-tooltip:before{content:"";position:absolute;top:50%;left:-10px;width:0;height:0;border:5px solid transparent;border:6px solid transparent\\0;border-right-color:inherit;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.vue-slider-component .vue-slider-dot.vue-slider-hover:hover .vue-slider-tooltip-wrap{display:block}.vue-slider-component .vue-slider-dot.vue-slider-always .vue-slider-tooltip-wrap{display:block!important}.vue-slider-component .vue-slider-piecewise{position:absolute;width:100%;padding:0;margin:0;left:0;top:0;height:100%;list-style:none}.vue-slider-component .vue-slider-piecewise-item{position:absolute;width:8px;height:8px}.vue-slider-component .vue-slider-piecewise-dot{position:absolute;left:50%;top:50%;width:100%;height:100%;display:inline-block;background-color:rgba(0,0,0,.16);border-radius:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);z-index:2;-webkit-transition:all .3s;transition:all .3s}.vue-slider-component .vue-slider-piecewise-item:first-child .vue-slider-piecewise-dot,.vue-slider-component .vue-slider-piecewise-item:last-child .vue-slider-piecewise-dot{visibility:hidden}.vue-slider-component.vue-slider-horizontal-reverse .vue-slider-piecewise-label,.vue-slider-component.vue-slider-horizontal .vue-slider-piecewise-label{position:absolute;display:inline-block;top:100%;left:50%;white-space:nowrap;font-size:12px;color:#333;-webkit-transform:translate(-50%,8px);transform:translate(-50%,8px);visibility:visible}.vue-slider-component.vue-slider-vertical-reverse .vue-slider-piecewise-label,.vue-slider-component.vue-slider-vertical .vue-slider-piecewise-label{position:absolute;display:inline-block;top:50%;left:100%;white-space:nowrap;font-size:12px;color:#333;-webkit-transform:translate(8px,-50%);transform:translate(8px,-50%);visibility:visible}.vue-slider-component .vue-slider-sr-only{clip:rect(1px,1px,1px,1px);height:1px;width:1px;overflow:hidden;position:absolute!important}',""])},function(t,e){t.exports=function(){var t=[];return t.toString=function(){for(var t=[],e=0;e<this.length;e++){var i=this[e];i[2]?t.push("@media "+i[2]+"{"+i[1]+"}"):t.push(i[1])}return t.join("")},t.i=function(e,i){"string"==typeof e&&(e=[[null,e,""]]);for(var s={},r=0;r<this.length;r++){var n=this[r][0];"number"==typeof n&&(s[n]=!0)}for(r=0;r<e.length;r++){var o=e[r];"number"==typeof o[0]&&s[o[0]]||(i&&!o[2]?o[2]=i:i&&(o[2]="("+o[2]+") and ("+i+")"),t.push(o))}},t}},function(t,e){t.exports=function(t,e,i,s){var r,n=t=t||{},o=typeof t.default;"object"!==o&&"function"!==o||(r=t,n=t.default);var l="function"==typeof n?n.options:n;if(e&&(l.render=e.render,l.staticRenderFns=e.staticRenderFns),i&&(l._scopeId=i),s){var a=Object.create(l.computed||null);Object.keys(s).forEach(function(t){var e=s[t];a[t]=function(){return e}}),l.computed=a}return{esModule:r,exports:n,options:l}}},function(t,e){t.exports={render:function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("div",{directives:[{name:"show",rawName:"v-show",value:t.show,expression:"show"}],ref:"wrap",class:["vue-slider-component",t.flowDirection,t.disabledClass,{"vue-slider-has-label":t.piecewiseLabel}],style:t.wrapStyles,on:{click:t.wrapClick}},[i("div",{ref:"elem",staticClass:"vue-slider",style:[t.elemStyles,t.bgStyle],attrs:{"aria-hidden":"true"}},[t.isRange?[i("div",{ref:"dot0",class:[t.tooltipStatus,"vue-slider-dot"],style:[t.dotStyles,t.sliderStyles[0]],on:{mousedown:function(e){t.moveStart(0)},touchstart:function(e){t.moveStart(0)}}},[i("span",{class:["vue-slider-tooltip-"+t.tooltipDirection[0],"vue-slider-tooltip-wrap"]},[t._t("tooltip",[i("span",{staticClass:"vue-slider-tooltip",style:t.tooltipStyles[0]},[t._v(t._s(t.formatter?t.formatting(t.val[0]):t.val[0]))])],{value:t.val[0],index:0})],2)]),t._v(" "),i("div",{ref:"dot1",class:[t.tooltipStatus,"vue-slider-dot"],style:[t.dotStyles,t.sliderStyles[1]],on:{mousedown:function(e){t.moveStart(1)},touchstart:function(e){t.moveStart(1)}}},[i("span",{class:["vue-slider-tooltip-"+t.tooltipDirection[1],"vue-slider-tooltip-wrap"]},[t._t("tooltip",[i("span",{staticClass:"vue-slider-tooltip",style:t.tooltipStyles[1]},[t._v(t._s(t.formatter?t.formatting(t.val[1]):t.val[1]))])],{value:t.val[1],index:1})],2)])]:[i("div",{ref:"dot",class:[t.tooltipStatus,"vue-slider-dot"],style:[t.dotStyles,t.sliderStyles],on:{mousedown:t.moveStart,touchstart:t.moveStart}},[i("span",{class:["vue-slider-tooltip-"+t.tooltipDirection,"vue-slider-tooltip-wrap"]},[t._t("tooltip",[i("span",{staticClass:"vue-slider-tooltip",style:t.tooltipStyles},[t._v(t._s(t.formatter?t.formatting(t.val):t.val))])],{value:t.val})],2)])],t._v(" "),i("ul",{staticClass:"vue-slider-piecewise"},t._l(t.piecewiseDotWrap,function(e,s){return i("li",{key:s,staticClass:"vue-slider-piecewise-item",style:[t.piecewiseDotStyle,e.style]},[t._t("piecewise",[t.piecewise?i("span",{staticClass:"vue-slider-piecewise-dot",style:[t.piecewiseStyle,e.inRange?t.piecewiseActiveStyle:null]}):t._e()],{label:e.label,index:s,first:0===s,last:s===t.piecewiseDotWrap.length-1}),t._v(" "),t._t("label",[t.piecewiseLabel?i("span",{staticClass:"vue-slider-piecewise-label",style:[t.labelStyle,e.inRange?t.labelActiveStyle:null]},[t._v("\n\t\t\t\t\t\t"+t._s(e.label)+"\n\t\t\t\t\t")]):t._e()],{label:e.label,index:s,first:0===s,last:s===t.piecewiseDotWrap.length-1})],2)})),t._v(" "),i("div",{ref:"process",staticClass:"vue-slider-process",style:t.processStyle})],2),t._v(" "),t.isRange||t.data?t._e():i("input",{directives:[{name:"model",rawName:"v-model",value:t.val,expression:"val"}],staticClass:"vue-slider-sr-only",attrs:{type:"range",min:t.min,max:t.max},domProps:{value:t.val},on:{__r:function(e){t.val=e.target.value}}})])},staticRenderFns:[]}},function(t,e,i){var s=i(3);"string"==typeof s&&(s=[[t.i,s,""]]),s.locals&&(t.exports=s.locals);i(8)("743d98f5",s,!0)},function(t,e,i){function s(t){for(var e=0;e<t.length;e++){var i=t[e],s=h[i.id];if(s){s.refs++;for(var r=0;r<s.parts.length;r++)s.parts[r](i.parts[r]);for(;r<i.parts.length;r++)s.parts.push(n(i.parts[r]));s.parts.length>i.parts.length&&(s.parts.length=i.parts.length)}else{for(var o=[],r=0;r<i.parts.length;r++)o.push(n(i.parts[r]));h[i.id]={id:i.id,refs:1,parts:o}}}}function r(){var t=document.createElement("style");return t.type="text/css",d.appendChild(t),t}function n(t){var e,i,s=document.querySelector('style[data-vue-ssr-id~="'+t.id+'"]');if(s){if(f)return v;s.parentNode.removeChild(s)}if(m){var n=c++;s=p||(p=r()),e=o.bind(null,s,n,!1),i=o.bind(null,s,n,!0)}else s=r(),e=l.bind(null,s),i=function(){s.parentNode.removeChild(s)};return e(t),function(s){if(s){if(s.css===t.css&&s.media===t.media&&s.sourceMap===t.sourceMap)return;e(t=s)}else i()}}function o(t,e,i,s){var r=i?"":s.css;if(t.styleSheet)t.styleSheet.cssText=g(e,r);else{var n=document.createTextNode(r),o=t.childNodes;o[e]&&t.removeChild(o[e]),o.length?t.insertBefore(n,o[e]):t.appendChild(n)}}function l(t,e){var i=e.css,s=e.media,r=e.sourceMap;if(s&&t.setAttribute("media",s),r&&(i+="\n/*# sourceURL="+r.sources[0]+" */",i+="\n/*# sourceMappingURL=data:application/json;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(r))))+" */"),t.styleSheet)t.styleSheet.cssText=i;else{for(;t.firstChild;)t.removeChild(t.firstChild);t.appendChild(document.createTextNode(i))}}var a="undefined"!=typeof document;if("undefined"!=typeof DEBUG&&DEBUG&&!a)throw new Error("vue-style-loader cannot be used in a non-browser environment. Use { target: 'node' } in your Webpack config to indicate a server-rendering environment.");var u=i(9),h={},d=a&&(document.head||document.getElementsByTagName("head")[0]),p=null,c=0,f=!1,v=function(){},m="undefined"!=typeof navigator&&/msie [6-9]\b/.test(navigator.userAgent.toLowerCase());t.exports=function(t,e,i){f=i;var r=u(t,e);return s(r),function(e){for(var i=[],n=0;n<r.length;n++){var o=r[n],l=h[o.id];l.refs--,i.push(l)}e?(r=u(t,e),s(r)):r=[];for(var n=0;n<i.length;n++){var l=i[n];if(0===l.refs){for(var a=0;a<l.parts.length;a++)l.parts[a]();delete h[l.id]}}}};var g=function(){var t=[];return function(e,i){return t[e]=i,t.filter(Boolean).join("\n")}}()},function(t,e){t.exports=function(t,e){for(var i=[],s={},r=0;r<e.length;r++){var n=e[r],o=n[0],l=n[1],a=n[2],u=n[3],h={id:t+":"+r,css:l,media:a,sourceMap:u};s[o]?s[o].parts.push(h):i.push(s[o]={id:o,parts:[h]})}return i}}])});

/***/ }),

/***/ 398:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid app app--red app--dobrodelen"},[_c('div',{staticClass:"app__width-container"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-lg-offset-1 col-lg-7 questions"},[(!_vm.actualAnswer1)?_c('div',{staticClass:"question clearfix",attrs:{"id":"question-1"}},[_c('div',{staticClass:"question__number"},[_vm._v("1")]),_vm._v(" "),_c('div',{staticClass:"question__content"},[_c('div',{staticClass:"question__label"},[_vm._v("\n            Kdo ste?\n          ")]),_vm._v(" "),_c('div',{staticClass:"question__answers"},[_c('form',[_c('div',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.answer1),expression:"answer1"}],attrs:{"type":"radio","id":"question-1-1","value":"person"},domProps:{"checked":_vm._q(_vm.answer1,"person")},on:{"change":function($event){_vm.answer1="person"}}}),_vm._v(" "),_c('label',{attrs:{"for":"question-1-1"}},[_vm._v("Posameznik/-ca, ki želi darovati del dohodnine")])]),_vm._v(" "),_c('div',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.answer1),expression:"answer1"}],attrs:{"type":"radio","id":"question-1-2","value":"org"},domProps:{"checked":_vm._q(_vm.answer1,"org")},on:{"change":function($event){_vm.answer1="org"}}}),_vm._v(" "),_c('label',{attrs:{"for":"question-1-2"}},[_vm._v("Organizacija, ki želi prejemati donacijo")])])])]),_vm._v(" "),_c('div',{staticClass:"question__button"},[_c('button',{staticClass:"btn btn-primary btn-external",attrs:{"type":"button","disabled":!_vm.answer1},on:{"click":_vm.onNextAnswer1}},[_vm._v("Naprej")])])])]):_vm._e(),_vm._v(" "),(_vm.actualAnswer1 === 'person')?[(!_vm.actualAnswer2)?_c('div',{staticClass:"question clearfix",attrs:{"id":"question-2"}},[_c('div',{staticClass:"question__number"},[_vm._v("2")]),_vm._v(" "),_c('div',{staticClass:"question__content"},[_c('div',{staticClass:"question__answers"},[_c('form',[_c('div',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.answer2),expression:"answer2"}],attrs:{"type":"radio","id":"question-2-1","value":"edavki"},domProps:{"checked":_vm._q(_vm.answer2,"edavki")},on:{"change":function($event){_vm.answer2="edavki"}}}),_vm._v(" "),_c('label',{attrs:{"for":"question-2-1"}},[_vm._v("Že imam izbrano organizacijo, daroval bom prek sistema eDavki.")])]),_vm._v(" "),_c('div',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.answer2),expression:"answer2"}],attrs:{"type":"radio","id":"question-2-2","value":"find_org"},domProps:{"checked":_vm._q(_vm.answer2,"find_org")},on:{"change":function($event){_vm.answer2="find_org"}}}),_vm._v(" "),_c('label',{attrs:{"for":"question-2-2"}},[_vm._v("Želim poiskati organizacijo oziroma izpolniti obrazec.")])])])]),_vm._v(" "),_c('div',{staticClass:"question__button"},[_c('button',{staticClass:"btn btn-primary btn-external",attrs:{"type":"button","disabled":!_vm.answer2},on:{"click":_vm.onNextAnswer2}},[_vm._v("Naprej")])])])]):_vm._e(),_vm._v(" "),(_vm.actualAnswer2 == 'edavki')?_c('div',{staticClass:"question clearfix",attrs:{"id":"question-3"}},[_c('div',{staticClass:"question__number"},[_vm._v("3")]),_vm._v(" "),_vm._m(2)]):_vm._e(),_vm._v(" "),(_vm.actualAnswer2 == 'find_org')?_c('div',{staticClass:"question clearfix",attrs:{"id":"question-3"}},[_c('div',{staticClass:"question__number"},[_vm._v("3")]),_vm._v(" "),_c('div',{staticClass:"question__content"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"question__answers"},[_c('form',[_c('div',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.answer3),expression:"answer3"}],attrs:{"type":"radio","id":"question-3-1","value":"1"},domProps:{"checked":_vm._q(_vm.answer3,"1")},on:{"change":function($event){_vm.answer3="1"}}}),_vm._v(" "),_c('label',{attrs:{"for":"question-3-1"}},[_vm._v("nazivu")])]),_vm._v(" "),_c('div',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.answer3),expression:"answer3"}],attrs:{"type":"radio","id":"question-3-2","value":"2"},domProps:{"checked":_vm._q(_vm.answer3,"2")},on:{"change":function($event){_vm.answer3="2"}}}),_vm._v(" "),_c('label',{attrs:{"for":"question-3-2"}},[_vm._v("davčni številki")])]),_vm._v(" "),_c('div',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.answer3),expression:"answer3"}],attrs:{"type":"radio","id":"question-3-3","value":"3"},domProps:{"checked":_vm._q(_vm.answer3,"3")},on:{"change":function($event){_vm.answer3="3"}}}),_vm._v(" "),_c('label',{attrs:{"for":"question-3-3"}},[_vm._v("poštni številki")])]),_vm._v(" "),_c('div',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.answer3),expression:"answer3"}],attrs:{"type":"radio","id":"question-3-4","value":"4"},domProps:{"checked":_vm._q(_vm.answer3,"4")},on:{"change":function($event){_vm.answer3="4"}}}),_vm._v(" "),_c('label',{attrs:{"for":"question-3-4"}},[_vm._v("področju")])])])]),_vm._v(" "),_c('div',{staticClass:"question__label"},[(_vm.answer3 === '1')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.findOrgKeyword),expression:"findOrgKeyword"}],staticClass:"form-control",attrs:{"placeholder":"Vpišite ključno besedo"},domProps:{"value":(_vm.findOrgKeyword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.findOrgKeyword=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.answer3 === '2')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.findOrgTaxNumber),expression:"findOrgTaxNumber"}],staticClass:"form-control",attrs:{"placeholder":"Vpišite davčno številko"},domProps:{"value":(_vm.findOrgTaxNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.findOrgTaxNumber=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.answer3 === '3')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.findOrgPostal),expression:"findOrgPostal"}],staticClass:"form-control",attrs:{"placeholder":"Vpišite poštno številko"},domProps:{"value":(_vm.findOrgPostal)},on:{"input":function($event){if($event.target.composing){ return; }_vm.findOrgPostal=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.answer3 === '4')?_c('search-dropdown',{attrs:{"single":"","placeholder":_vm.areasPlaceholder,"items":_vm.areas},on:{"change":function (v) { return _vm.findOrgArea = v.value; }}}):_vm._e()],1),_vm._v(" "),(_vm.findOrgLoading)?_c('div',{staticClass:"question__label"},[_c('div',{staticClass:"loader"})]):_vm._e(),_vm._v(" "),(_vm.findOrgResults)?_c('div',{staticClass:"question__label"},[_c('p',[_vm._v("Rezultati ("+_vm._s(_vm.findOrgResults.length)+"):")]),_vm._v(" "),_c('div',{staticClass:"star-list"},_vm._l((_vm.findOrgResults),function(org){return _c('div',{class:['star-list__entry', { 'star-list__entry--selected': _vm.isSelectedOrg(org) }],on:{"click":function($event){_vm.selectOrg(org)}}},[_vm._v("\n                  "+_vm._s(org.name)+"\n                ")])}))]):_vm._e(),_vm._v(" "),(_vm.selectedTooMany)?_c('div',{staticClass:"question__label"},[_vm._m(4)]):_vm._e(),_vm._v(" "),(_vm.selected_orgs.length)?_c('div',{staticClass:"question__label"},[_c('p',[_vm._v("Izbrane organizacije:")]),_vm._v(" "),_c('ul',{staticClass:"question__selected-list"},_vm._l((_vm.selected_orgs),function(org){return _c('li',{key:org.tax_number},[_c('small',[_c('strong',[_vm._v(_vm._s(org.name))]),_vm._v(" (DŠ: "+_vm._s(org.tax_number)+")")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Remove","title":"Odstrani"},on:{"click":function($event){$event.preventDefault();_vm.selectOrg(org)}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])])})),_vm._v(" "),_c('p',{staticClass:"text-center question__button"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();_vm.selectRatios($event)}}},[_vm._v("Nadaljuj z odmero dela dohodnine")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();_vm.continueToEdavki($event)}}},[_vm._v("Daruj preko sistema eDavki")])])]):_vm._e()])]):_vm._e(),_vm._v(" "),(!_vm.showSelectRatios && _vm.answer4 == 'edavki')?_c('div',{staticClass:"question clearfix",attrs:{"id":"question-4"}},[_c('div',{staticClass:"question__number"},[_vm._v("4")]),_vm._v(" "),_vm._m(5)]):_vm._e(),_vm._v(" "),(_vm.actualAnswer2 == 'find_org' && _vm.showSelectRatios)?_c('div',{staticClass:"question clearfix",attrs:{"id":"question-4"}},[_c('div',{staticClass:"question__number"},[_vm._v("4")]),_vm._v(" "),_c('div',{staticClass:"question__content"},[_c('div',{staticClass:"question__answers"},[_vm._l((_vm.selected_orgs),function(org,index){return [_c('p',[_c('small',[_vm._v(_vm._s(org.name))])]),_vm._v(" "),_c('div',{staticClass:"range-slider"},[_c('vue-slider',_vm._b({attrs:{"disabled":_vm.selected_ratios.length <= 1},on:{"input":function($event){_vm.recalculateRatios(index)}},model:{value:(_vm.selected_ratios[index]),callback:function ($$v) {_vm.$set(_vm.selected_ratios, index, $$v)},expression:"selected_ratios[index]"}},'vue-slider',_vm.sliderOptions,false)),_vm._v(" "),_c('input',{staticClass:"form-control range-slider__value",attrs:{"disabled":""},domProps:{"value":(_vm.selected_ratios[index] / 100) + '%'}})],1)]})],2),_vm._v(" "),_vm._m(6),_vm._v(" "),_c('p',{staticClass:"text-center question__button"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();_vm.showPersonInfoForm($event)}}},[_vm._v("Nadaljuj z izpolnjevanjem obrazca")])])])]):_vm._e(),_vm._v(" "),(_vm.actualAnswer2 == 'find_org' && _vm.shouldShowPersonInfoForm)?_c('div',{staticClass:"question clearfix",attrs:{"id":"question-5"}},[_c('div',{staticClass:"question__number"},[_vm._v("5")]),_vm._v(" "),_c('div',{staticClass:"question__content"},[_c('form',{attrs:{"action":"/pdf/genPDFfromPOST/","method":"POST"}},[_c('input',{attrs:{"type":"hidden","name":"template","value":"dobrodelen_pdf"}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"filename","value":"obrazec_enprocent"}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"source_domain","value":"cnvos.si/enprocent"}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"selected_orgs"},domProps:{"value":_vm.selectedOrgsForFormValue}}),_vm._v(" "),_c('div',{staticClass:"question__answers"},[_c('div',{staticClass:"form-controls row"},[_c('div',{staticClass:"col-sm-12 control-input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.personInfoForm.name),expression:"personInfoForm.name"}],staticClass:"form-control",attrs:{"placeholder":"Ime in priimek","name":"name"},domProps:{"value":(_vm.personInfoForm.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.personInfoForm, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-12 control-input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.personInfoForm.address),expression:"personInfoForm.address"}],staticClass:"form-control",attrs:{"placeholder":"Naslov","name":"address"},domProps:{"value":(_vm.personInfoForm.address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.personInfoForm, "address", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-4 control-input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.personInfoForm.postalCode),expression:"personInfoForm.postalCode"}],staticClass:"form-control",attrs:{"placeholder":"Poštna številka","name":"postalCode","maxlength":"4"},domProps:{"value":(_vm.personInfoForm.postalCode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.personInfoForm, "postalCode", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-8 control-input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.personInfoForm.city),expression:"personInfoForm.city"}],staticClass:"form-control",attrs:{"placeholder":"Kraj","name":"city"},domProps:{"value":(_vm.personInfoForm.city)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.personInfoForm, "city", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-12 control-input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.personInfoForm.taxNumber),expression:"personInfoForm.taxNumber"}],staticClass:"form-control",attrs:{"placeholder":"Davčna številka","name":"taxNumber"},domProps:{"value":(_vm.personInfoForm.taxNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.personInfoForm, "taxNumber", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-12 control-input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.personInfoForm.email),expression:"personInfoForm.email"}],staticClass:"form-control",attrs:{"placeholder":"Elektronski naslov","name":"email"},domProps:{"value":(_vm.personInfoForm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.personInfoForm, "email", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-12 control-input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.personInfoForm.phone),expression:"personInfoForm.phone"}],staticClass:"form-control",attrs:{"placeholder":"Telefonska številka","name":"phone"},domProps:{"value":(_vm.personInfoForm.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.personInfoForm, "phone", $event.target.value)}}})])])]),_vm._v(" "),_c('p',[_vm._v("\n                Ko boste izpolnili obrazec, imate dve možnosti:\n              ")]),_vm._v(" "),_vm._m(7),_vm._v(" "),_c('p',{staticClass:"text-center question__button"},[(!_vm.shouldShowSignatureForm || _vm.personInfoFormHasErrors)?_c('button',{staticClass:"btn btn-primary",attrs:{"disabled":_vm.personInfoFormHasErrors}},[_c('i',{staticClass:"glyphicon glyphicon-download-alt"}),_vm._v(" Prenesi in pošlji obrazec sam\n                ")]):_vm._e(),_vm._v(" "),(_vm.showSendToCnvosButton)?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":_vm.personInfoFormHasErrors},on:{"click":function($event){$event.preventDefault();_vm.showSignatureForm($event)}}},[_c('i',{staticClass:"glyphicon glyphicon-pencil"}),_vm._v(" Podpiši in posreduj CNVOS-u\n                ")]):_vm._e()])])])]):_vm._e(),_vm._v(" "),(_vm.shouldShowSignatureForm && !_vm.personInfoFormHasErrors)?_c('div',{staticClass:"question clearfix",attrs:{"id":"question-6"}},[_c('div',{staticClass:"question__number"},[_vm._v("6")]),_vm._v(" "),_c('div',{staticClass:"question__content"},[_c('form',{attrs:{"action":"/pdf/genPDFfromPOST/","method":"POST"}},[_c('input',{attrs:{"type":"hidden","name":"template","value":"dobrodelen_pdf"}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"filename","value":"obrazec_enprocent"}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"source_domain","value":"cnvos.si/enprocent"}}),_vm._v(" "),(_vm.signedPdfSubmitted)?_c('input',{attrs:{"type":"hidden","name":"skip_save","value":"true"}}):_vm._e(),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"selected_orgs"},domProps:{"value":_vm.selectedOrgsForFormValue}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"name"},domProps:{"value":_vm.personInfoForm.name}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"address"},domProps:{"value":_vm.personInfoForm.address}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"postalCode"},domProps:{"value":_vm.personInfoForm.postalCode}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"city"},domProps:{"value":_vm.personInfoForm.city}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"taxNumber"},domProps:{"value":_vm.personInfoForm.taxNumber}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"email"},domProps:{"value":_vm.personInfoForm.email}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"phone"},domProps:{"value":_vm.personInfoForm.phone}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"signature"},domProps:{"value":_vm.signatureDataUrl}}),_vm._v(" "),(!_vm.signedPdfSubmitted)?[_c('p',[_vm._v("Podpišite se v spodnje polje — če naprava podpira dotik, lahko uporabite prst ali digitalni svinčnik, drugače pa miško.")]),_vm._v(" "),_vm._m(8),_vm._v(" "),_c('p',[_c('signature-pad',{key:_vm.signaturePadKey,on:{"ready":_vm.onSignatureReady,"change":_vm.onSignatureChange}})],1),_vm._v(" "),_c('div',[_c('button',{staticClass:"btn btn-link btn-sm",staticStyle:{"padding":"0"},attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.resetSignature($event)}}},[_vm._v("Izbriši podpis")])]),_vm._v(" "),_c('p',{staticClass:"text-center question__button"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":_vm.signatureFormHasErrors},on:{"click":function($event){$event.preventDefault();_vm.onSubmitPDF($event)}}},[_vm._v("\n                    Potrdi in posreduj obrazec CNVOS-u\n                  ")])])]:[_vm._m(9),_vm._v(" "),_c('p',{staticClass:"text-center question__button"},[_c('button',{staticClass:"btn btn-primary",attrs:{"disabled":_vm.signatureFormHasErrors}},[_c('i',{staticClass:"glyphicon glyphicon-download-alt"}),_vm._v(" Prenesi kopijo obrazca\n                  ")])])]],2)])]):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.actualAnswer1 === 'org')?[(_vm.actualAnswer1 === 'org' && !_vm.actualAnswer2)?_c('div',{staticClass:"question clearfix",attrs:{"id":"question-2"}},[_c('div',{staticClass:"question__number"},[_vm._v("2")]),_vm._v(" "),_c('div',{staticClass:"question__content"},[_c('div',{staticClass:"question__answers"},[_c('form',[_c('div',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.answer2),expression:"answer2"}],attrs:{"type":"radio","id":"question-2-1","value":"become"},domProps:{"checked":_vm._q(_vm.answer2,"become")},on:{"change":function($event){_vm.answer2="become"}}}),_vm._v(" "),_c('label',{attrs:{"for":"question-2-1"}},[_vm._v("Želim postati upravičenec/prejemnik donacij.")])]),_vm._v(" "),_c('div',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.answer2),expression:"answer2"}],attrs:{"type":"radio","id":"question-2-2","value":"plugin"},domProps:{"checked":_vm._q(_vm.answer2,"plugin")},on:{"change":function($event){_vm.answer2="plugin"}}}),_vm._v(" "),_c('label',{attrs:{"for":"question-2-2"}},[_vm._v("Sem že upravičenec in želim gradnik za svoje spletno mesto.")])])])]),_vm._v(" "),_c('div',{staticClass:"question__button"},[_c('button',{staticClass:"btn btn-primary btn-external",attrs:{"type":"button","disabled":!_vm.answer2},on:{"click":_vm.onNextAnswer2}},[_vm._v("Naprej")])])])]):_vm._e(),_vm._v(" "),(_vm.actualAnswer2 == 'become')?[_c('div',{staticClass:"question clearfix",attrs:{"id":"question-3"}},[_c('div',{staticClass:"question__number"},[_vm._v("3")]),_vm._v(" "),_c('div',{staticClass:"question__content"},[_c('div',{staticClass:"question__label"},[_vm._v("\n                Izberite področje dela\n              ")]),_vm._v(" "),_c('div',{staticClass:"question__answers"},[(_vm.dobrodelenKeysBecome && _vm.dobrodelenKeysBecome.pravne_oblike && _vm.dobrodelenKeysBecome.vsebine)?_c('form',[(_vm.areasOrgItems)?_c('search-dropdown',{attrs:{"placeholder":_vm.areasOrgPlaceholder,"items":_vm.areasOrgItems,"single":""},on:{"change":_vm.checkBecomeForm}}):_vm._e()],1):_vm._e()])])]),_vm._v(" "),(_vm.actualAnswer2 == 'become' && _vm.legalFormSelected.length && _vm.areasOrgSelected.length)?_c('div',{staticClass:"question clearfix",attrs:{"id":"question-4"}},[_c('div',{staticClass:"question__number"},[_vm._v("4")]),_vm._v(" "),(_vm.becomeContentText)?_c('div',{staticClass:"question__content"},[(_vm.becomeTitleText)?_c('div',{staticClass:"info__title info__title--alone"},[_c('h2',[_vm._v(_vm._s(_vm.becomeTitleText))])]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"externallinks",rawName:"v-externallinks"},{name:"tooltips",rawName:"v-tooltips"}],staticClass:"question__label block-paragraph",domProps:{"innerHTML":_vm._s(_vm.becomeContentText)}})]):_vm._e()]):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.actualAnswer2 == 'plugin')?_c('div',{staticClass:"question clearfix",attrs:{"id":"question-3"}},[_c('div',{staticClass:"question__number"},[_vm._v("3")]),_vm._v(" "),_c('div',{staticClass:"question__content"},[_vm._m(10),_vm._v(" "),_c('div',{staticClass:"question__answers"},[_c('form',{on:{"submit":function($event){$event.preventDefault();}}},[_c('div',{staticClass:"form-controls row"},[_c('div',{staticClass:"col-sm-12 control-input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ngoInfoForm.taxNumber),expression:"ngoInfoForm.taxNumber"}],staticClass:"form-control",attrs:{"placeholder":"Davčna številka","maxlength":"8"},domProps:{"value":(_vm.ngoInfoForm.taxNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.ngoInfoForm, "taxNumber", $event.target.value)}}}),_vm._v(" "),(_vm.ngoInfoFormTaxNumberNotFound)?_c('strong',{staticClass:"small text-danger"},[_vm._v("Ta davčna številka ni upravičena do donacij dohodnine.")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-sm-12 control-input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ngoInfoForm.name),expression:"ngoInfoForm.name"}],staticClass:"form-control",attrs:{"placeholder":"Naziv organizacije","disabled":!_vm.ngoInfoFormHasValidTaxNumber},domProps:{"value":(_vm.ngoInfoForm.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.ngoInfoForm, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-12 control-input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ngoInfoForm.address),expression:"ngoInfoForm.address"}],staticClass:"form-control",attrs:{"placeholder":"Naslov","disabled":!_vm.ngoInfoFormHasValidTaxNumber},domProps:{"value":(_vm.ngoInfoForm.address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.ngoInfoForm, "address", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-4 control-input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ngoInfoForm.postalCode),expression:"ngoInfoForm.postalCode"}],staticClass:"form-control",attrs:{"placeholder":"Poštna številka","disabled":!_vm.ngoInfoFormHasValidTaxNumber,"maxlength":"4"},domProps:{"value":(_vm.ngoInfoForm.postalCode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.ngoInfoForm, "postalCode", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-8 control-input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ngoInfoForm.city),expression:"ngoInfoForm.city"}],staticClass:"form-control",attrs:{"placeholder":"Kraj","disabled":!_vm.ngoInfoFormHasValidTaxNumber},domProps:{"value":(_vm.ngoInfoForm.city)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.ngoInfoForm, "city", $event.target.value)}}})])])])]),_vm._v(" "),_c('p',{staticClass:"text-center question__button"},[_c('button',{staticClass:"btn btn-primary",attrs:{"disabled":_vm.ngoInfoFormHasErrors},on:{"click":_vm.showWidgetPreview}},[_vm._v("predogled")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"disabled":_vm.ngoInfoFormHasErrors},on:{"click":_vm.copyWidgetCode}},[_vm._v("kopiraj kodo")])]),_vm._v(" "),(_vm.copiedWidgetCode)?_c('p',{staticClass:"text-center question__button"},[_vm._v("\n              HTML koda skopirana v odložišče\n            ")]):_vm._e()]),_vm._v(" "),(_vm.showingWidgetPreview)?_c('div',{staticClass:"question__label row",attrs:{"id":"widget-preview"}},[_c('widget-two',_vm._b({attrs:{"percent":"1.0","source-domain":"cnvos.si"}},'widget-two',_vm.ngoInfoForm,false))],1):_vm._e()]):_vm._e()]:_vm._e()],2)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"app__title"},[_c('h1',[_c('span',[_vm._v("1 %")]),_vm._v(" dohodnine")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-offset-1 col-lg-10"},[_c('div',{staticClass:"jumbotron"},[_c('p',[_vm._v("Vsak, ki v Sloveniji plačuje dohodnino, lahko do 1 % svoje dohodnine nameni nevladnim organizacijam. Vsak davčni zavezanec lahko izbere največ deset organizacij in s tem odstotek svoje dohodnine nameni za njihovo delovanje. Takšna donacija ga nič ne stane, saj gre ta odstotek sicer v proračun.")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"question__content"},[_c('div',[_c('p',[_vm._v("Zahtevo za namenitev dela dohodnine za donacije je možno oddati kadarkoli prek sistema eDavki z digitalnim potrdilom ali brez. Če želite v eDavke vstopiti brez digitalnega potrdila, boste potrebovali svojo "),_c('strong',[_vm._v("davčno številko")]),_vm._v(" in "),_c('strong',[_vm._v("številko zadnjega informativnega izračuna dohodnine")]),_vm._v(". Za namenitev dela dohodnine pa boste potrebovali še "),_c('strong',[_vm._v("davčno številko izbrane organizacije")]),_vm._v(".")]),_vm._v(" "),_c('p',[_vm._v("Davčni organ upošteva veljavne zahteve, s katerimi razpolaga na dan 31. decembra tistega leta, za katero se dohodnina odmerja. Za leto 2024 tako velja, da bo davčni organ upošteval veljavne zahtevke, s katerimi bo razpolagal do 31. decembra 2024. Zahteva velja do trenutka, ko davčni organ prejme novo zahtevo ali preklic zahteve.")])]),_vm._v(" "),_c('div',{staticClass:"question__button"},[_c('a',{staticClass:"btn btn-primary btn-external",attrs:{"href":"https://edavki.durs.si/EdavkiPortal/OpenPortal/CommonPages/Opdynp/PageD.aspx?category=namenitev_dela_dohodnine_fo","target":"_blank"}},[_vm._v("pojdi na eDavke")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"question__label"},[_c('p',[_c('strong',[_vm._v("Izberete lahko od 1 do 10 organizacij, med katerimi lahko porazdelite do 1 % svoje dohodnine. Če še niste povsem odločeni, jih dodajte s klikom na zvezdico. Izbor boste lahko pred izpolnitvijo obrazca še enkrat uredili.")])]),_vm._v(" "),_c('p',{attrs:{"id":"find-org-radios"}},[_vm._v("IŠČI PO:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',{staticClass:"text-danger"},[_vm._v("Izberete lahko največ 10 orgranizacij!")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"question__content"},[_c('div',{staticClass:"question__label"},[_c('p',[_vm._v("Zahtevo za namenitev dela dohodnine za donacije je možno oddati kadarkoli prek sistema eDavki z digitalnim potrdilom ali brez. Če želite v eDavke vstopiti brez digitalnega potrdila, boste potrebovali svojo "),_c('strong',[_vm._v("davčno številko")]),_vm._v(" in "),_c('strong',[_vm._v("številko zadnjega informativnega izračuna dohodnine")]),_vm._v(". Za namenitev dela dohodnine pa boste potrebovali še "),_c('strong',[_vm._v("davčno številko izbrane organizacije")]),_vm._v(".")]),_vm._v(" "),_c('p',[_vm._v("Davčni organ upošteva veljavne zahteve, s katerimi razpolaga na dan 31. decembra tistega leta, za katero se dohodnina odmerja. Za leto 2024 tako velja, da bo davčni organ upošteval veljavne zahtevke, s katerimi bo razpolagal do 31. decembra 2024. Zahteva velja do trenutka, ko davčni organ prejme novo zahtevo ali preklic zahteve.")]),_vm._v(" "),_c('p',{staticClass:"question__button"},[_c('a',{staticClass:"btn btn-primary btn-external",attrs:{"href":"https://edavki.durs.si/EdavkiPortal/OpenPortal/CommonPages/Opdynp/PageD.aspx?category=namenitev_dela_dohodnine_fo","target":"_blank"}},[_vm._v("pojdi na eDavke")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"question__label"},[_c('p',[_vm._v("Če ste pomotoma dodali kakšno organizacijo, ki ji ne želite donirati dela dohodnine, izberite 0%.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',[_c('li',[_vm._v("\n                  Če želite podatke sami posredovati Fursu, boste prejeli PDF datoteko. To natisnete in posredujete Fursu.  V tem primeru ne shranjujemo nobenih\n                  vaših podatkov.\n                ")]),_vm._v(" "),_c('li',[_vm._v("\n                  Lahko pa vse uredite elektronsko ter tiskanje in pošiljanje prepustite nam. Obrazce bomo posredovali Fursu vsakega 28. v mesecu, razen decembra\n                  že 20. v mesecu. Vaše podatke bomo izbrisali dan po tem, ko bomo vaš obrazec poslali Fursu. Več o splošnih pogojih uporabe in obdelavi osebnih\n                  podatkov si preberite "),_c('a',{attrs:{"href":"https://www.cnvos.si/nvo-vseved/enprocent/splosni-pogoji/","target":"_blank"}},[_vm._v("tukaj")]),_vm._v(".\n                ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\n                  Obrazce bomo pošiljali Fursu vsak 28. dan v mesecu, razen decembra, ko bomo obrazce poslali že 20. v mesecu. Več o  splošnih pogojih\n                  uporabe in obdelavi osebnih podatkov si preberite "),_c('a',{attrs:{"href":"https://www.cnvos.si/nvo-vseved/enprocent/splosni-pogoji/","target":"_blank"}},[_vm._v("tukaj")]),_vm._v(".\n                  S posredovanjem obrazca CNVOS se strinjate, da CNVOS v vašem imenu obrazec pošlje na Furs.\n                ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"text-center",staticStyle:{"margin-top":"3rem","font-weight":"700"}},[_vm._v("\n                  Hvala, prejeli smo vaš obrazec. Če imate kakršna koli vprašanja, nam pišite na "),_c('a',{attrs:{"href":"mailto:info@cnvos.si","target":"_blank"}},[_vm._v("info@cnvos.si")]),_vm._v(".\n                ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"question__label"},[_c('p',[_vm._v("\n                Za nevladne organizacije, ki ste skladno z Uredbo o namenitvi dela dohodnine za donacije upravičene do donacij, smo pripravili posebno\n                aplikacijo. Gradnik si lahko brezplačno namestite na svojo spletno stran. V spodnji obrazec vpišite informacije o svoji organizaciji.\n                Ko vnesete vse podatke, kliknite na gumb 'kopiraj kodo' ter kodo prilepite v HTML kodo svojega spletnega mesta. Davčni zavezanci bodo\n                v gradnik na vaši spletni strani vnesli svoje podatke, natisnili obvestilo ter svojo odločitev sporočili na finančni urad oziroma\n                obrazec podpisali in ga poslali na CNVOS. Obrazce bomo na Furs pošiljali vsak 28. dan v mesecu, razen decembra, ko bomo obrazce\n                odposlali 20. v mesecu.\n              ")]),_vm._v(" "),_c('p',[_vm._v("\n                Podatki, ki jih bodo davčni zavezanci vpisovali v obrazec na vaši spletni strani, se pri vas ne shranjujejo.\n              ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 56:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(57);
var objectAssign = __webpack_require__(58);
var decodeComponent = __webpack_require__(59);

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

exports.extract = function (str) {
	return str.split('?')[1] || '';
};

exports.parse = function (str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^(\?|#|&)/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeComponent(val);

		formatter(decodeComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
};

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort().map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};


/***/ }),

/***/ 57:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ }),

/***/ 58:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),

/***/ 59:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var token = '%[a-f0-9]{2}';
var singleMatcher = new RegExp(token, 'gi');
var multiMatcher = new RegExp('(' + token + ')+', 'gi');

function decodeComponents(components, split) {
	try {
		// Try to decode the entire string first
		return decodeURIComponent(components.join(''));
	} catch (err) {
		// Do nothing
	}

	if (components.length === 1) {
		return components;
	}

	split = split || 1;

	// Split the array in 2 parts
	var left = components.slice(0, split);
	var right = components.slice(split);

	return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
}

function decode(input) {
	try {
		return decodeURIComponent(input);
	} catch (err) {
		var tokens = input.match(singleMatcher);

		for (var i = 1; i < tokens.length; i++) {
			input = decodeComponents(tokens, i).join('');

			tokens = input.match(singleMatcher);
		}

		return input;
	}
}

function customDecodeURIComponent(input) {
	// Keep track of all the replacements and prefill the map with the `BOM`
	var replaceMap = {
		'%FE%FF': '\uFFFD\uFFFD',
		'%FF%FE': '\uFFFD\uFFFD'
	};

	var match = multiMatcher.exec(input);
	while (match) {
		try {
			// Decode as big chunks as possible
			replaceMap[match[0]] = decodeURIComponent(match[0]);
		} catch (err) {
			var result = decode(match[0]);

			if (result !== match[0]) {
				replaceMap[match[0]] = result;
			}
		}

		match = multiMatcher.exec(input);
	}

	// Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
	replaceMap['%C2'] = '\uFFFD';

	var entries = Object.keys(replaceMap);

	for (var i = 0; i < entries.length; i++) {
		// Replace all decoded components
		var key = entries[i];
		input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
	}

	return input;
}

module.exports = function (encodedURI) {
	if (typeof encodedURI !== 'string') {
		throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
	}

	try {
		encodedURI = encodedURI.replace(/\+/g, ' ');

		// Try the built in decoder first
		return decodeURIComponent(encodedURI);
	} catch (err) {
		// Fallback to a more advanced decoder
		return customDecodeURIComponent(encodedURI);
	}
};


/***/ }),

/***/ 88:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SignaturePad_vue__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f348213_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignaturePad_vue__ = __webpack_require__(136);
function injectStyle (ssrContext) {
  __webpack_require__(132)
}
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0f348213"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SignaturePad_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f348213_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignaturePad_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ })

},[392]);


// WEBPACK FOOTER //
// js/dobrodelen.16df5ef187a0b92e0ac4.js